import services from './../../../services/service'; // Service Class
import validation from './../../../services/validation'; // Service Class
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer
import Orders from './../../Orderpoint/Orders/index.vue'; //Your Orders
import Collections from './../../Collections/index.vue'; //Your Orders
import ProductItemForm from '../../../components/product/ProductItemForm.vue'
import AccountDropMenu from '../../../components/templates/account-menu.vue'

let service = new services();
let validator = new validation();

export default {
    name: 'Account',
    data () {
        return {
            //defaults
            user: {},
            sellpoints:{},
            sellpoint:{},
            business:{}, //binds to sellpoints
            products:{},
            product:{},
            product_item_group:{},
            product_item:{},
            categories:{},
            category:{},
            main_category:{},
            sub_categories:[],
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            sellpoint_gallery:{},
            galleria:{},
            lookbooks:{},
            lookbook:{},
            lookbook_post:{},
            menu_view:{},
            menu_tab_view:{},
            menu_tab_inner_view:{},
            is_view:"",
            is_viewing:"Account",
            is_viewed: "Account",
            is_view_type: "Account",
            img_url: service.imageURL,
            server_query_done:false,
            setPanel: false,
            loading:true,
            action_loading:false,
            disable_btn:false,
            data_processing_message:"",
            data_error_message:"",
            data_success_message:"",
            data_media_error_message:"",
            max_media_info:service.max_upload_image_info,
            max_plan_lookbooks:0,
            max_plan_lookbook_posts:0,
            total_lookbooks_added:0,
            can_add_more_lookbook:false,
            can_add_product_lookbook:false,
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            setSettings:false,
            setting_details:{},
            //.../defaults

            //more settings
            states:{},
            cities:{},
            delivery_option:{},
            other_delivery_option:false,
            edit_other_delivery_option:false,
            custom_delivery_option:false,
            component_view:{viewProducts:true,viewProduct:false,viewLookbooks:true,viewLookbook:false,viewLookbookPost:false,},
            business_details:{delivery_edit:false,delivery_add:false,delivery_option_edit:false,viewDiscounts:true,setDiscount:false},
            product_details:{},
            lookbook_details:{},
            manageList:["manageBusinesses","manageProducts","manageServices","manageLookbooks"],
            manage:["manageBusinesses","manageProducts","manageServices","manageLookbooks"],
            discount_coupon:{},
            managePanel:false,
            manageBusinesses:true, //default view
            manageProducts:false,
            manageServices:false,
            manageLookbooks:false,
            managePosts:false,
            manageOrders:false,
            manageBusinessDetails:false,
            businessComponents: ["BusinessEditing","BusinessDeliveryShipping","BusinessCoupons","BusinessPaymentGateway"],
            business_set_shipping_fee_status:9,
            addDeliveryInformation:false,
            editDeliveryInformation:false,
            product_set_shipping_fee_status:12,
            set_shipping_fee_status_track:false,

            //business settings
            business_agent:0,
            business_open_agents_products:{},
            business_product_categories:[],
            business_service_categories:[],
            business_category_type:0,
            validate_user_name_error:false,
            validate_user_name_message:"",
            
            //product settings
            product_display_image:{},
            product_item:{},
            file_info: {},
            files_info:[], //muttiple files
            imageForm: "",
            imagesFormArray: [], //multiple files
            is_product_service: "product",
            max_upload: service.max_media_upload,
            
            
            //productitems settings
            show_product_setting_box:false,
            // showProductItemGroups: true,
            showProductItemGroups:"",
            tap_01:0,
            //...more--settings

            //loobook settings
            viewing_lookbook: {}, //store viewing lookbook for product swich
            viewing_lookbook_post:{},
            is_viewing_lookbook: false,

            //posts settings
            post:{},
            posts:{},
            viewPost:false,

            //core confirmed settings
            current_sellpoint_id:0,
            market_groups: {},
            app_orders:{},
            order:{},
            viewOrder:false,
            sellpoint_orders:{},
            sellpoint_transactions:{},
            processing_fee:{},
            //payment gateways
            payment_gateways:{}, 
            ravepay_bank_list:{},
            ravepay_sba:{}, //ravepay_subaccount

            //
            set_reward_type_amount_type:"C", //default
            prdItemPriceKey:0,

            //keys
            businessComponentKey:1,
            orderComponentKey:1,
            productVariationComponentKey:1,
            productOrdersComponentKey:1,
            attachProductsComponentKey:1,
            
        }
    },

    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'product-item-form': ProductItemForm,
        'component-account-menu': AccountDropMenu,
        'component-orders': Orders,
        'component-collections': Collections,
    },
     
    methods: {

        back(){
            this.unsetPageHeaders();
            if(!this.setPanel){
                window.history.back(); 
            }else{
                if(this.is_viewed == "Account"){
                    this.setPanel = false;
                }else{
                    this.setMenuComponent(this.is_viewed,this.is_view_type,'','')
                }
            }
            // this.setPanel = false;//hack
            //some hacks
            this.menu_tab_view = {};
        },

        numStrip(){
            this.product.product_item_price = this.product.product_item_price.replace( /[^0-9.,]/g, '' );
            this.prdItemPriceKey++;    
        },

        numStrip01(){
            this.product.product_items[0].product_item_price = this.product.product_items[0].product_item_price.replace( /[^0-9.,]/g, '' );
            this.prdItemPriceKey++;    
        },

        toggleSingleComponent(component){
            let toggle = document.getElementById(component).style.display;
            if(toggle == "block"){
                document.getElementById(component).style.display = "none";
            }else{
                document.getElementById(component).style.display = "block";
            }
        },

        toggleTrippleComponent(component1,component2,component3){
            let toggle1 = document.getElementById(component1).style.display;
            let toggle2 = document.getElementById(component2).style.display;
            let toggle3 = document.getElementById(component3).style.display;
            if(toggle1 == "block"){
                document.getElementById(component1).style.display = "none";
            }else{
                document.getElementById(component1).style.display = "block";
            }
            if(toggle2 == "block"){
                document.getElementById(component2).style.display = "none";
            }else{
                document.getElementById(component2).style.display = "block";
            }
            if(toggle3 == "block"){
                document.getElementById(component3).style.display = "none";
            }else{
                document.getElementById(component3).style.display = "block";
            }
        },

        //---default--settings
        reloadToView(){
            //store preset components //use ids
            this.current_sellpoint_id = this.sellpoint.business_id;
            // let on_view_sellpoint = this.sellpoint;
            // let on_view_category = this.category;
            // let on_view_product = this.product;
            // let on_view_product_item = this.product_item;

            let view_1 = Object.keys(this.menu_view)[0];
            let view_2 = Object.keys(this.menu_tab_view)[0];
            //load more
            
            //reload preset
            this.preset(); 
            // console.log(Object.keys(this.menu_view)[0])
            // console.log(this.menu_tab_view[Object.keys(this.menu_tab_view)[0]])

            //reset unset
            // this.sellpoint = on_view_sellpoint;
            // this.category = on_view_category;
            // this.product = on_view_product;
            // this.product_item = on_view_product_item;
            //more

            //then set view
            this.setMenuComponent(view_1,'','');
            this.setMenuTabView(view_2,'','');
        },

        setMenuComponent(view,view_type,attr1,attr2){  
            this.setPanel = true;
            
            var top = document.getElementById("topPanel").offsetTop;
            window.scrollTo(0, top); 

            this.menu_view = {};
            this.menu_view[view] = true;
            
            if(this.is_viewing == ''){this.is_viewing = view;}
            
            //set view tree
            this.setViewTree(view,view_type,attr1,attr2);

            //scaler//activator
           this.resetPageSettings(view);
        },

        resetPageSettings(view){
            if((view == 'viewBusiness') || (view == 'viewBusinessCategory') || (view == 'viewBusinessCategoryProduct')){
                this.setPageHeaders(view);
                setTimeout(function(){ 
                    if(document.getElementById(view) != null){
                        document.getElementById(view).style.color = service.app_default_color;
                    }
                }, 50);
            }
        },

        setMenuTabView(view,attr1,attr2){
            // var top = document.getElementById("topPanel").offsetTop;
            // window.scrollTo(0, top); 
            this.setComponent('reset-edit','');
            this.menu_tab_inner_view = {};
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
            //some settings
            this.activateMenuTabView(view);
        },

        activateMenuTabView(view){
            //unactivate
            var tabs = document.getElementsByClassName('tab-menu-link');
            for (var i = 0; i < tabs.length; i++) {
                tabs[i].style = "color:inherit;";
            } 
            //../unactivate

            //activate
            let tab_menu = document.getElementById(view);
            if(tab_menu != undefined){
                tab_menu.style.color = service.app_default_color;
            }
        },

        setMenuTabInnerView(view,attr1,attr2){
            this.setComponent('reset-edit','');
            this.menu_tab_inner_view = {};
            this.menu_tab_inner_view[view] = true;
        },


        setViewTree(view,view_type,attr1,attr2){
            //config -- parent node configs
            if((view_type == "sellpoints") || (view_type == "business")){ //sellpoint has a special config
                this.is_view_type = "business";
            }else{
                this.is_view_type = view_type;
            }
            //other configs for parent nodes
            // if(view_type == "buypoints"){}
            //../config -- parent node configs
            //get menu view that is true, ie current
            if(this.is_view_type == "business"){
                //business
                //ist level
                let view_array_b1 = ["viewBusiness",];
                //2nd level
                let view_array_b2 = ["manageBusiness","viewBusinessCategory","newBusinessCategory"];
                //3rd level
                let view_array_b3 = ["setBusinessProfile","setBusinessOrders","setBusinessShippingInformation","setBusinessShippingLocations","setBusinessDiscountsCoupons","setBusinessPaymentInformation","setBusinessDeleteRequest"];

                //category
                let view_array_bc1 = ["manageBusinessCategory","viewBusinessCategoryProduct","newBusinessCategoryProduct"];
                //product
                let view_array_bcp1 = ["manageBusinessCategoryProduct"];
                let view_array_bcp2 = ["setBusinessCategoryProductDetails","setBusinessCategoryProductItems","setBusinessCategoryProductDiscountCoupons","setBusinessCategoryProductDeliveryAndReturanInformation","setBusinessCategoryProductShippingInformation"];
               
                //some  inner core settings befor view is set
                if(this.is_view == "newBusinessCategoryProduct"){this.product={};this.resetAll();}//reset
                //some  inner core settings befor view is set

                if(this.is_view == "viewBusiness"){
                    this.is_viewed = 'sellpoints';
                }else if(this.is_view == "sellpoints"){
                    this.is_viewed = "Account";
                }else{
                    if(view_array_b2.indexOf(this.is_view) != -1){
                        this.is_viewed = "viewBusiness"; 
                    }else if(view_array_b3.indexOf(this.is_view) != -1){
                        this.is_viewed = "manageBusiness";
                    }else if(view_array_bc1.indexOf(this.is_view) != -1){
                        this.is_viewed = "viewBusinessCategory"; this.businessComponentKey++;
                    }else if(view_array_bcp1.indexOf(this.is_view) != -1){
                        this.is_viewed = "viewBusinessCategoryProduct";
                    }else if(view_array_bcp2.indexOf(this.is_view) != -1){
                        this.is_viewed = "manageBusinessCategoryProduct";
                    }else{
                        this.is_viewed = "viewBusiness";
                    }
                    // this.is_viewed = "Account"; //store 
                    
                }
                this.is_view = this.is_viewed; //instantiate is_view prep if back btn is pressed 
                // if(view != "sellpoints"){
                //     this.is_viewed = "viewBusiness";
                // }else{
                //     this.is_viewed = "sellpoints";
                // }
                //more is viewed settings
                
    
            }
            // console.log("BB---is_view_type::"+this.is_view_type+"---is_view::"+this.is_view+"---is_viewed::"+this.is_viewed)
            //other view types
            
        },

        setBusinessComponent(view,attr1,attr2){
            this.resetMessages();
            // console.log(this.is_view+"---"+this.is_viewed)
            this.setPanel = true;
            this.resetPageSettings(view); //page headers and menus
            if(view != "sellpoints"){
                this.sellpoint = attr1;
            }else{
                this.setMenuTabView('viewBusiness');
            }
            // this.is_viewed = this.is_view;
            this.is_view = view;
            this.is_view_type = "business";
            this.is_viewing = this.sellpoint.business_username;  //this.sellpoint.business_name

            //new entries check
            let entry_array = ["newBusiness","newBusinessCategory","newBusinessCategoryProduct","newBusinessAgentCategoryProduct"];
            
            if(entry_array.indexOf(view) != -1){
                if(view == 'newBusiness'){this.sellpoint = {};}
                if(view == 'newBusinessCategory'){this.main_category = {}; this.category = {};}
                if(view == 'newBusinessCategoryProduct'){this.product = {};}
                if(view == 'newBusinessAgentCategoryProduct'){this.product = {};}
            }
            //sellpoint check
            //agent special
            if(view == 'viewBusiness'){
                this.setMenuTabView('viewBusiness');
                // this.setPageHeaders();
                // setTimeout(function(){ document.getElementById('viewBusiness').style.color = service.app_default_color }, 500); //wait for 3sec and call posts in gallery
            }
            this.main_category = {};
            //categories check
            let category_array = ["viewBusinessCategory","editBusinessCategory","removeBusinessCategory"];
            
            if(category_array.indexOf(view) != -1){
                this.category = attr2;
                
                //agent special
                if(view == 'viewBusinessCategory'){
                    this.getBusinessCategoryProducts();
                    if(this.sellpoint.business_agent == 1){
                        this.getBusinessAgentCategoryProducts();
                        this.getBusinessesIsOpenAgentCategoryProducts();
                    }
                    this.setMenuTabView('viewBusinessCategory');
                    // this.setPageHeaders();
                    // setTimeout(function(){ document.getElementById('viewBusinessCategory').style.color = service.app_default_color }, 1500); //wait for 3sec and call posts in gallery
                
                }
            }


            //products check
            let product_array = ["viewBusinessCategoryProduct","editBusinessCategoryProduct","removeBusinessCategoryProduct"];
            
            if(product_array.indexOf(view) != -1){
                // this.product = attr2;
                this.getSetProduct(attr2);
                //this two lines below is now called in the function above
                // this.product_display_image = this.product.product_images[0];
                // this.product_item = this.product.product_items[0];

                //restore settings
                this.is_viewed = "viewBusinessCategory";
                // this.category = 
                //agent special
                if(view == 'viewBusinessCategoryProduct'){
                    this.setMenuTabView('viewBusinessCategoryProduct');
                    // this.setPageHeaders();
                    // setTimeout(function(){ document.getElementById('viewBusinessCategoryProduct').style.color = service.app_default_color }, 500); //wait for 3sec and call posts in gallery
                }
            }


            
            this.menu_view = {};
            this.menu_view[view] = true;
            this.setViewTree(view,"sellpoints",attr1,attr2); 
        },

        getSetProduct(item){
            service.getProductSearch(this, item.product_url_name).then(response => {
                if(response.body.status == 200) {
                    this.product = response.body.data;
                    this.product_display_image = this.product.product_images[0];
                    this.product_item = this.product.product_items[0];
                    // if(this.product.product_item_groups.length != 0){
                    //     this.product_item_group = this.product.product_item_groups[0];
                    // }else{
                    //     this.product_item_group = [];
                    // }
                    
                    //new hack to make sure category is set for back options
                    if(Object.keys(this.category).length === 0){
                        //set this product's category
                        for(let category of this.sellpoint.business_categories){
                            if(this.product.product_category_id == category.business_category_id){
                                this.category = category;
                                //other settings
                                this.getBusinessCategoryProducts();  /// try filter already sellpoint products for PERf
                            }
                        }
                    }
                    
                    //filter orders
                    this.product.product_orders = [];
                    for(let ord of this.sellpoint.orders){
                        for(let ord_item of ord.order_items){
                            if(this.product.product_id == ord_item.product_id){
                                let ord_array = {};
                                ord_array.order_product = ord_item.product_id; 
                                ord_array.order_date = ord.order_date; 
                                ord_array.order_time_ago = ord.order_time_ago; 
                                ord_array.order_user = ord.order_user;
                                ord_array.order_item_quantity = ord_item.order_item_quantity;
                                ord_array.order_status_id = ord.order_status_id; 
                                ord_array.order_status = ord.order_status;
                                ord_array.order_status_color = ord.order_status_color; 
                                ord_array.order_payment_status_id = ord.order_payment_status_id;
                                ord_array.order_payment_status = ord.order_payment_status;
                                ord_array.order_payment_status_color = ord.order_payment_status_color;
                                this.product.product_orders.push(ord_array);
                                this.productOrdersComponentKey++;
                            }
                        }
                    }
                }
            }).catch((err) => {})
        },

        getSetProductDEPAC(item){
            // get from current category
            for(let prd of this.category.category_products){
                if(prd.product_url_name == item.product_url_name){
                    this.product = prd;
                    this.product_display_image = this.product.product_images[0];
                    this.product_item = this.product.product_items[0];
                }else{
                    // this.product = item;
                }
            }
        },

        setComponent(attr1,attr2){
            // this.resetAll();
            this.data_processing_message = ""; //refresh
            this.deactivate_processing(); //first deactivate any active processing

            if(attr1 == 'set-settings-inner'){
                this.setSettings = true;
                this.setting_details = {};
                this.setting_details[attr2] = true;
            }

            if(attr1 == 'manage-panel'){
                this.setPanel = true;
                this.managePanel = true;
                this.manage[0] = true; //default
            }

            if(attr1 == 'set-business-card-details'){
                this.manageBusinessDetails = true;
                this.setBusinessComponent(attr2);
            }

            if(attr1 == 'set-business-details'){
                this.discount_coupon = {};
                this.business_details = {};
                this.business_details[attr2] = true;
            }

            if(attr1 == 'edit-delivery-option'){
                this.delivery_option.edit_set = false;
                this.business_details = {};
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                if(this.delivery_option.business_delivery_is_custom == 0)
                {
                    this.getCities(this.delivery_option.business_delivery_state,'edit'); //option edit
                }
                this.business_details["delivery_option_edit"] = true;
            }

            if(attr1 == 'edit-discount-coupon'){
                this.business_details = {};
                this.discount_coupon.edit = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }

            if(attr1 == 'manage-businesses'){
                this.manageBusinesses = true;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-products'){
                this.manageBusinesses = false;
                this.manageProducts = true;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-services'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = true;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-lookbooks'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = true;
                this.managePosts = false;
                this.manageOrders = false;
                // this.component_view.viewLookbooks = true
            }

            if(attr1 == 'manage-posts'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = true;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-orders'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = false;
                this.manageOrders = true;
            }

            

            if(attr1 == 'reset-edit'){ 
                // this.menu_tab_view = {};
                // this.menu_tab_inner_view = {};
                this.discount_coupon = {};
                this.business_details = {};
                this.product_details = {};
                this.lookbook_details = {};
                this.setting_details ={};
                this.main_category = {}; //recheck
                this.setSettings = false;
                this.viewOrder = false;
                this.viewPost = false;
                this.data_success_message = "";
                this.data_error_message = "";
                this.data_processing_message= "";
                this.showProductItemGroups = "";
            }

            if(attr1 == 'reset-component-details'){
                this.manageBusinessDetails = false;
            }
            
            //more ///move up after app_clean
            if(attr1 == "orders"){
                this.order = attr2;
                this.viewOrder = true;
            }

            if(attr1 == "posts"){
                this.post = attr2;
                this.viewPost = true;
            }
            

        },

        setComponentXX(attr1,attr2){
            this.resetAll();
            this.data_processing_message = ""; //refresh
            this.deactivate_processing(); //first deactivate any active processing

            if(attr1 == 'set-settings-inner'){
                this.setSettings = true;
                this.setting_details = {};
                this.setting_details[attr2] = true;
            }

            if(attr1 == 'manage-panel'){
                this.setPanel = true;
                this.managePanel = true;
                this.manage[0] = true; //default
            }

            if(attr1 == 'set-business-card-details'){
                this.manageBusinessDetails = true;
                this.setBusinessComponent(attr2);
            }

            if(attr1 == 'set-business-details'){
                this.discount_coupon = {};
                this.business_details = {};
                this.business_details[attr2] = true;
            }

            if(attr1 == 'edit-delivery-option'){
                this.delivery_option.edit_set = false;
                this.business_details = {};
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                this.getCities(this.delivery_option.business_delivery_state,'edit'); //option edit
                this.business_details["delivery_option_edit"] = true;
            }

            if(attr1 == 'edit-discount-coupon'){
                this.business_details = {};
                this.discount_coupon.edit = false;
                this.discount_coupon = attr2;
                this.discount_coupon.edit = true;
            }

            if(attr1 == 'manage-businesses'){
                this.manageBusinesses = true;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-products'){
                this.manageBusinesses = false;
                this.manageProducts = true;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-services'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = true;
                this.manageLookbooks = false;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-lookbooks'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = true;
                this.managePosts = false;
                this.manageOrders = false;
                // this.component_view.viewLookbooks = true
            }

            if(attr1 == 'manage-posts'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = true;
                this.manageOrders = false;
            }

            if(attr1 == 'manage-orders'){
                this.manageBusinesses = false;
                this.manageProducts = false;
                this.manageServices = false;
                this.manageLookbooks = false;
                this.managePosts = false;
                this.manageOrders = true;
            }

            

            if(attr1 == 'reset-edit'){
                this.menu_tab_view = {};
                this.menu_tab_inner_view = {};
                this.discount_coupon = {};
                this.business_details = {};
                this.product_details = {};
                this.lookbook_details = {};
                this.setting_details ={};
                this.setSettings = false;
                this.data_success_message = "";
                this.data_error_message = "";
                this.data_processing_message= "";

                //
                this.deactivate_processing();//rc
            }

            if(attr1 == 'reset-component-details'){
                this.manageBusinessDetails = false;
            }
            
            

        },

        setInnerComponent(attr1,attr2){
            //product-items--add--imports
            if(attr1 == 'set-product-item-group'){
                this.product.product_item_group = attr2;
                //styling to show selecte active group
                var grps = document.getElementsByClassName('product-item-group');
                for (var i = 0; i < grps.length; i++) {
                    grps[i].style = "border:none;";
                } 
                // document.getElementById(attr2+"PRTGR").style.border = "1px solid #0000CC";
                document.getElementById(attr2+"PRTGR").style= "border:1px solid #0000CC;min-width:65px; max-width:65px;";
            }
            if(attr1 == 'set-product-item-group-image'){
                this.product.product_item_group_image = attr2;
                var imgs = document.getElementsByClassName('product-item-group-image');
                for (var i = 0; i < imgs.length; i++) {
                    imgs[i].style = "border:none;";
                //    imgs[i].style = "padding:20px;border:1px solid #bbb;";
                } 
                document.getElementById(attr2+"PRTG").style.border = "1px solid #0000CC";
            }
            //product-items--add-imports

        },

        //reset main substitute
        resetAll(){
            this.discount_coupon = {};
            this.business_details = {};
            this.product_details = {};
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message= "";
        },

        resetMessages(){
            this.data_success_message = "";
            this.data_error_message = "";
            this.data_processing_message= "";
            this.deactivate_processing(); //hack in here
        },

        resetFormData(){
            this.file_info = {};
            this.files_info = [];
        },
       
        setComponentView(attr1,attr2,attr3){
            this.resetAll();
            if(attr1 == 'switch-to-viewing-loobook'){ //a special toggle switch case
                //switcth to lookbook view
                this.setComponent('manage-lookbooks',''); //topmost layout
                this.lookbook = this.viewing_lookbook;
                this.setComponentView('loobooks',this.viewing_lookbook_post,'viewLookbookPost');

                //reset
                this.is_viewing_lookbook = false;
                this.viewing_lookbook = {};
                this.viewing_lookbook_post = {};

            }
            if(attr1 == 'products'){
                if(this.component_view.viewProducts){
                    this.component_view.viewProducts = false;
                    this.component_view.viewProduct = true;
                    this.product = attr2;
                    //some products settings
                    this.product_set_shipping_fee_status =  this.product.product_set_shipping_fee_status;
                    // localStorage.setItem("viewing-01", this.product.product_url_name);
                }
                else if(this.component_view.viewProduct){
                    this.component_view.viewProducts = true;
                    this.component_view.viewProduct = false;
                }
                
            }
            if(attr1 == 'lookbooks'){
                if(attr3 == 'viewLookbookPost'){ //setting post in lookbook
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = true;
                    this.lookbook_post = attr2;
                    //some lookbook_post settings
                    //localStorage.setItem("viewing-02", this.lookbook_post.post_url_name);
                }
                else if(attr3 == 'viewLookbook'){ //sets lookbook in lookbooks
                    this.component_view.viewLookbooks = false;
                    this.component_view.viewLookbookPost = false;
                    this.component_view.viewLookbook = true;
                    this.lookbook = attr2;
                }
                else if(attr3 == 'viewLookbooks'){ //sets lookbooks ../default
                    this.component_view.viewLookbooks = true;
                    this.component_view.viewLookbook = false;
                    this.component_view.viewLookbookPost = false;
                }
                
            }
        },

        toggleProductItemView(component,attr2,attr3,attr4){
            //close all existing
            var grps = document.getElementsByClassName('product-item-show-more-details');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:none;";
            } 
            var grps = document.getElementsByClassName('product-item-more-details-hide-btn');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:none;";
            } 
            var grps = document.getElementsByClassName('product-item-more-details-view-btn');
            for (var i = 0; i < grps.length; i++) {
                grps[i].style = "display:block;";
            } 
            //
            if(component == "showMoreProductItemDetails"){
                document.getElementById(attr2).style.display = "block";
                document.getElementById(attr3).style.display = "none"; //viewbtn
                document.getElementById(attr4).style.display = "block"; //hidebtn
                
            }
            if(component == "hideMoreProductItemDetails"){
                document.getElementById(attr3).style.display = "block"; //viewbtn
                document.getElementById(attr4).style.display = "none"; //hidebtn
            }
        },

        setProductComponent(component,attr2,attr3){
            this.deactivate_processing(); //first deactivate any active processing
            this.discount_coupon = {}; //reset

            if(component == "show-settings-box"){
                this.show_product_setting_box = true;
            }
            if(component == "hide-settings-box"){
                this.show_product_setting_box = false;
            }
            
            if(attr2 == 'productitemgroup'){
                this.product_item_group = attr3;
            }
            if(attr2 == 'productitem'){
                this.product_item = attr3;
            }

            //some settings
            // if(component == "hideMoreProductItemDetails"){
            //     this.menu_tab_view["showMoreProductItemDetails"] = false;
            // }
            if(component == "addProductItemPanel"){
                if(this.product.product_set_groups == 0){
                    this.showProductItemGroups = 'showfalse'; //no items found
                }
            }
            if(component == 'setProductDeliveryInformation'){
                this.delivery_option.edit_set = false;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
            }
            if(component == 'editDiscount'){
                this.discount_coupon = attr3;
            }
            if(component == 'deactivateDiscount'){
                this.product_item = attr2;
                this.deactivateDiscountsAndCoupons(attr3)
            }

            this.product_details = {};
            this.product_details[component] = true;
        },

        setLookbookComponent(component,attr2,attr3){
            this.deactivate_processing(); //first deactivate any active processing

            if(component == "viewProductLookbookPost"){//navigate to product lookbook page //store parent lookbook
                this.viewing_lookbook = this.lookbook; //store parent lookbook
                this.viewing_lookbook_post = attr3; //store the product post
                this.is_viewing_lookbook =  true; //save activity

                //switch to product view
                this.setComponent('manage-products',''); //topmost layout
                this.setComponentView('products',attr3.gallery_post_product_details,''); //set the product view
            }else{
                //other settings

                this.lookbook_details = {};
                this.lookbook_details[component] = true;    
            }

            


        },

        toggleSwitchBusiness(){
            var x = document.getElementById("businessList");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        },

        switchBusiness(sellpoint){
            this.sellpoint = sellpoint;
            this.galleria = {}; //a hack for refresh
            this.setSellpoint();
            //check if toggle effect
            this.toggleSwitchBusiness();
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
            // this.resetAll();
            //refresh without reloading
            this.$router.push('/account') //use as hack for now, //find faster approach
            // this.data_success_message = "";
            // this.data_error_message = "";
            // this.data_processing_message = "";
        },

        checkIfVideo(url){
            if(url != undefined){
                let ext = url.split('.').pop();
                if(service.video_exts.includes(ext)){
                    return true;
                }else{
                    return false;
                }
            }
        },

        reset(){
            this.setPanel = false;
            this.managePanel = false;
        },

        getStates(){
            service.getStates(this).then(response => {
                if(response.body.status == 200) {
                    this.states = response.body.data;
                }
            }).catch((err) => {})
        },

        getCities(state,option){
            this.activate_processing();
            if(option == "edit"){this.edit_city = true;}
            else{this.edit_city = false}
            service.getCities(this,state).then(response => {
                if(response.body.status == 200) {
                    this.cities = response.body.data;
                    this.deactivate_processing();
                }else{
                    this.deactivate_processing();
                }
            }).catch((err) => {
                this.deactivate_processing();
            })
        },

        preset_xtra() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        this.server_query_done = true;
                        let data = response.body.data;
                        data.forEach(function(element) {
                           this.user.user_id = element.user_id;
                            //special case for profile
                            service.getUser(this, element.user_id).then(data => {
                                if(data.body.status == 200) {
                                    //get other user details
                                    let user_data = data.body.data;
                                    this.user.user_email = user_data.user_email;
                                    this.user.user_member_id = user_data.user_member_id;
                                    this.user.user_name = user_data.user_name;
                                    this.user.user_phone = user_data.user_phone;
                                    this.user.user_token = user_data.user_token;

                                    // this.user = data.body.data;
                                    //get sellpoints
                                    this.getSellpoints(element.user_id);
                                }
                            }).catch((err) => {
                                if(err) {
                                    // toastr.error('Sorry, could not process information', 'Warning!');
                                }
                            })
                         //../special case for profile
                         }, this);
                    }else {
                        //reauth or ..login
                      this.$router.push('/login/');
                      }
                }).catch((err) => {
                    if(err) {
                        //console.log(err)
                      //  this.$router.push('/login/');
                    }
                })
            }else {
                //this.$router.push('/login/');
            }
        },

        preset() {
            this.loading = true;
            let self = this;
        
            ///
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    //special case for profile
                    self.getUser(self.user.user_id);
                    //../special case for profile
                    // self.loading = false;
                }else {
                    self.$router.push('login');
                }
            });
        },

        getUser(user_id){
            service.getUser(this, user_id).then(data => {
                if(data.body.status == 200) {
                    //get other user details
                    let user_data = data.body.data;
                    this.user.user_email = user_data.user_email;
                    this.user.user_member_id = user_data.user_member_id;
                    this.user.user_name = user_data.user_name;
                    this.user.user_phone = user_data.user_phone;
                    this.user.user_token = user_data.user_token;

                    //set main view
                    if(this.$route.query.t == "newsp"){
                        this.is_viewing = "Account";
                        this.setBusinessComponent('newBusiness','');
                    }

                    this.loading = false;
                    // this.user = data.body.data;
                    //get sellpoints
                    this.getSellpoints(user_id);
                }
            }).catch((err) => {
                if(err) {
                    // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        syncset(request_page){
            //get auth key
            var credentials = {
                session_key: localStorage.getItem("sp_token"),
                request_url: service.app_url,
                request_from: service.app_name,
                request_status: "REQUESTING...",
                request: request_page,
            } 
            if(credentials.session_key != null) {
                //save session and request on server
                service.sessionSync(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        //redirect to sp with session ref
                        let ref = response.body.data;
                        window.location.href = service.sp_url+'/manage/'+ref;
                    }
                }).catch((err) => {
                    if(err) {
                       // console.log(err)
                       // this.$router.push('/login/');
                    }
                })
            }
        },

        //profile
        editProfileDetails(){
            this.activate_processing();
            var payload = {
                user_name: this.user.user_name,
                user_phone: this.user.user_phone,
                user_email: this.user.user_email
            }

            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if((email_test == false) || (this.user.user_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_processing_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            }else{
                data_test = true;
                this.data_processing_message = "";
            }
            if(data_test){
                if(payload.user_name != null && payload.user_phone != null) {
                    service.editProfileDetails(this, payload).then(function(data) {
                        if(data.body.status == 200) {
                            this.data_processing_message = "Profile Updated";
                            this.user = data.body.data;
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details={};
                        }else{
                            this.data_processing_message = "Could not edit details, something went wrong, please try again";
                            this.deactivate_processing();
                            this.setSettings = false;
                            this.setting_details={};
                        }
                        
                    }).catch((err) => {
                        //log it
                        this.data_processing_message = "Could not edit details, something went wrong, please try again";
                        this.deactivate_processing();
                        this.setSettings = false;
                        this.setting_details={};
                    })
                }
            }
        },
        //./profile

        getSellpoints(user){
            // this.loading = true; //disable for now
            this.loading = false;
            service.getAppBusinesses(this, user).then(data => {
                if(data.body.status == 200) {
                    this.sellpoints = data.body.data;
                    if(this.current_sellpoint_id != 0){
                        for(let sellpoint of this.sellpoints){
                            if(sellpoint.business_id == this.current_sellpoint_id){
                                this.sellpoint = sellpoint;
                            }
                        }
                    }else{
                        this.sellpoint = this.sellpoints[0];
                    }
                    this.business_set_shipping_fee_status = this.sellpoint.business_set_shipping_fee_status;
                    //get the gallery of the sellpoint
                    this.setSellpoint();
                    this.loading = false; //disable for now
                }
            }).catch((err) => {
                if(err) {
                   //log it
                  // console.log(err)
                }
            })
        },

        setSellpoint(){ 
           this.activate_processing();
           //some settings
            if(this.sellpoint.business_category_type == 1){
                this.is_product_service = "product";
            }
            if(this.sellpoint.business_category_type == 2){
                this.is_product_service = "service";
            }
            //get Products
            // this.getSellpointProductsDEPRAC(); //hack here for  now for /// get requests like get posts
            //get Orders
            this.getAppBusinessOrders();
            //get transactions
            this.getAppBusinessTransactions();
            this.getBusinessRewardSettings();
            //continue
            //new-get new categories
            this.getMainCategories(this.sellpoint.business_category_id);
            //set sellpoint categories
            this.getSellpointCategories();
            //get integrated services
            this.getIntegratedServices();
            //get posts
            this.getAppBusinessPosts();
        },

        setSellpointDEPRAC(){ 
            this.activate_processing();
            service.getAppBusinessByUserName(this, this.sellpoint.business_username).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_gallery = response.body.data; 

                    //get this sellpoint products
                    this.getSellpointProducts();
                    //get Orders
                    // this.sellpoint.orders = {};
                    this.getAppBusinessOrders();
                    // this.sellpoint.reward_settings = {}; //initialise
                    this.getBusinessRewardSettings();
                    
                    //dummy settings
                    if(this.sellpoint_gallery.business_market_subscription_name == 'Free Plan'){
                        this.max_plan_lookbooks = 2;
                        this.max_plan_lookbook_posts = 5;
                    }
                    if(this.sellpoint_gallery.business_market_subscription_name == 'Basic Plan'){
                        this.max_plan_lookbooks = 10;
                        this.max_plan_lookbook_posts = 50; //unlimited
                    }
                    if(this.sellpoint_gallery.business_market_subscription_name == 'Premium Plan'){
                        this.max_plan_lookbooks = 50;//unlimited
                        this.max_plan_lookbook_posts = 50;//unlimited
                        this.can_add_product_lookbook = true; //online shop functionality
                    }
                    
                    let self = this;
                    setTimeout(function(){ self.setGallery(); }, 3000); //wait for 3sec and call posts in gallery
                    
                    //continue
                    //new-get new categories
                    this.getCategories(this.sellpoint.business_category_id);
                    //set sellpoint categories
                    this.getSellpointCategories();
                    
                }
            }).catch((err) => {})
            
        },

        setGallery(){
            service.getPointGalleryPosts(this, this.sellpoint.business_id,0,this.max_plan_lookbooks,0,this.max_plan_lookbook_posts).then(response => {
                this.galleria = response.body.data;
                //settings
                this.total_lookbooks_added = response.body.total_data;

                if(this.total_lookbooks_added < this.max_plan_lookbooks){
                    this.can_add_more_lookbook = true;
                }
                this.deactivate_processing();
            }).catch((err) => {})
        },

        getSellpointProductsDEPRAC(){
            this.sellpoint.business_market_products_limit = 1000; //hack in here
            service.getAppBusinessProducts(this, this.sellpoint.business_id, this.sellpoint.business_market_products_limit).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data; 
                } 
            }).catch((err) => {})
        },
    
            
        ////../default settings

        /*----------------------Adminboarding------------------------------------------*/
        //market settings
        getBusinessMarketGroups() {
            service.getBusinessMarketGroups(this).then(function(data) {
                this.market_groups = data.body.data;
            })
        },

        //business--settings
        getCategories() {
            service.getCategories(this).then(function(data) {
                let categories = data.body.data;
                //seperate products and services categories
                categories.forEach(function(element) {
                    if(element.category_type == 1){
                        this.business_product_categories.push(element);
                    }
                    if(element.category_type == 2){
                        this.business_service_categories.push(element);
                    }
                }, this);
            })
        },

        getMainCategories(category){
            service.getMainCategories(this, category).then(response => {
               if(response.body.status == 200) {
                    this.categories = response.body.data;
                }
            }).catch((err) => {})
        },

        getSubCategories(category){
            if(category != undefined){
                this.sub_categories = category.sub_categories;
            }else{
                this.sub_categories = [];
            }
            
        },

        //categories settings
        getSellpointCategories(){
            service.getBusinessCategories(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_categories = response.body.data;
                }
            }).catch((err) => {})
        },

        getBusinessCategoryProducts(){
            this.loading = true;
            service.getCategoryProducts(this, this.category.business_category_id).then(response => {
                if(response.body.status == 200) {
                  this.category.category_products = response.body.data;
                  this.businessComponentKey++;
                  this.attachProductsComponentKey++;
                }this.loading = false;
            }).catch((err) => {this.loading = false})
        },
        
        //RCPFX performance_recheck
        
        getBusinessesIsOpenAgentCategoryProducts(){
            var payload = {
                'business_category': this.category.business_category,
                'business_parent_category': this.category.business_parent_category_id,
                'business_category_type': this.category.business_category_type,
            }
            service.getBusinessesOpenAgentsCategoryProducts(this, payload).then(response => {
                if(response.body.status == 200) {
                  this.category.category_business_open_for_agent_products = response.body.data;
                  this.businessComponentKey++;
                }
            }).catch((err) => {})
        },

        getBusinessAgentCategoryProducts(){
            service.getAgentsBusinessCategoryProducts(this, this.category.business_category_id).then(response => {
                if(response.body.status == 200) {
                  this.category.category_products = response.body.data;
                  this.businessComponentKey++;
                }
            }).catch((err) => {})
        },

        getBusinessesOpenAgentsProducts(){
            service.getBusinessesOpenAgentsProducts(this).then(response => {
                if(response.body.status == 200) {
                  this.business_open_agents_products = response.body.data;
                }
            }).catch((err) => {})
        },

        resetCategoriesSelections(){
            if(this.category.new_listed_category != ''){
                this.main_category = {};
                this.category.new_category = 0;
            }
        },

        addCategory(){
            this.activate_processing();
            var payload = {
                category_new: this.category.new_category || 0,
                category_new_listed: this.category.new_listed_category || "nill",
                category_parent: this.main_category.category_id || 0,
                business_id: this.sellpoint.business_id
            }
            // if((payload.category_new == 0) && (payload.category_new_listed == "nill")){
            if((payload.category_parent == 0) && (payload.category_new == 0) && (payload.category_new_listed == "nill")){
                this.data_error_message = "You did not pick any category, Select or any enter the category name";
                this.deactivate_processing();
            }else{
                service.addCategory(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Sellpoint Category Added Successfully";
                        this.sellpoint.business_categories = data.body.data;
                        this.category = {};
                    }else{
                        this.data_error_message = "Sorry could not process request, try again";
                    }
                    this.deactivate_processing();
                    this.setBusinessComponent("viewBusiness",this.sellpoint,''); //back
                }).catch((err) => {
                    //log it
                    this.data_error_message = "Sorry could not process request, try again";
                    this.deactivate_processing();
                })
            }
            
        },

        editCategory(){
            this.activate_processing();
            this.category.business_id = this.sellpoint.business_id;
            service.editCategory(this, this.category).then(function(data) {
                if(data.body.status == 200) {
                    // toastr.success("Sellpoint Category edited", 'Success!');
                    this.data_processing_message = "Sellpoint Category edited";
                    this.sellpoint.business_categories = data.body.data;
                    this.setComponent('reset-edit','');
                    this.deactivate_processing();
                    // this.category = {};
                }
            }).catch((err) => {
                this.data_processing_message = "Sellpoint Category could not be edited";
                this.setComponent('reset-edit','');
            })
        },

        deleteCategory(){
            this.setComponent('reset-edit','');
            // this.category.business_id = this.sellpoint.business_id;
            // service.editCategory(this, this.category).then(function(data) {
            //     if(data.body.status == 200) {
            //         // toastr.success("Sellpoint Category edited", 'Success!');
            //         this.data_processing_message = "Sellpoint Category edited";
            //         this.sellpoint.business_categories = data.body.data;
            //         this.setComponent('reset-edit','');
            //         // this.category = {};
            //     }
            // }).catch((err) => {
            //     this.data_processing_message = "Sellpoint Category could not be edited";
            //     this.setComponent('reset-edit','');
            // })
        },

        //validate user name
        validateUserName(){
            service.validateBusinessUserName(this, this.business).then(response => {
                if(response.body.status != 200) {
                    this.validate_user_name_error = true;
                    this.validate_user_name_message = "This username already exist";
                    this.deactivate_processing();
                }
            }).catch((err) => {
                //log it
                this.validate_user_name_error = true;
                this.validate_user_name_message = "This username already exist";
                this.deactivate_processing();
            })
        },

        ///if payment for market plans exist for this marktet
        //.purchase plan
        //.marke purchase order
        //.set up business
        //.notify payment
        //.reroute //or stay in account
        //////./

        //add new business // //market business registration with basic free payment
        setUpNewBusiness(){
            this.resetAll();
            // this.disable_btn = true;
            this.activate_processing();
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_market_group: this.business.business_market_group, //market group in this market
                business_layout: 1, //shop
                business_agent: this.business_agent, //shop
                business_subscription: 1 //defalut / basic //no payment to register in this market     
            }
            let navi = this.$router;
            if(this.validate_user_name_error){
                this.data_error_message = "This Username already exists..";
                this.deactivate_processing();
            }else{
                if(credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            // toastr.success("Sellpoint Creation Successfull", 'Success!');
                            this.business.business_user_name = data.body.data_business_username; //overide from server
                            this.data_processing_message = "Sellpoint Creation Successful.";

                            //notify server of Order-Delivered
                            // this.notifyPayments(16,this.payment_ref,this.business.business_user_name); //16--Subscription-Delivered
                            
                            this.sellpoint = data.body.data;
                            //navigate to business view

                            this.setBusinessComponent('viewBusiness',this.sellpoint,'');
                            this.reloadToView();//core_reload
                            this.deactivate_processing();
                            this.resetAll();
                        }else{
                            this.data_error_message = "This Username already exists";
                            this.deactivate_processing();
                        }
                    }).catch((err) => {
                        if(err) {
                            this.data_error_message = "Something went wrong";
                            this.deactivate_processing();
                        }
                    })
                }else {
                    this.data_error_message = "Kindly fill all fields";
                    this.deactivate_processing();
                }
            }
        },

        //editbusiness
        editBusinessDetails(attr){
            this.activate_processing();
            if(attr == "delivery"){
                var payload = {
                    business_id: this.sellpoint.business_id,
                    business_delivery_information: this.sellpoint.business_delivery_information
                }
            }else{
                var payload = {
                    business_main_details:true,
                    business_id: this.sellpoint.business_id,
                    business_name: this.sellpoint.business_name,
                    business_tagline: this.sellpoint.business_tagline,
                    business_profile: this.sellpoint.business_profile,
                    business_emails: this.sellpoint.business_emails,
                    business_address: this.sellpoint.business_address,
                    business_phones: this.sellpoint.business_phones
                }
            }
            service.editBusinessDetails(this, payload).then(function(data) {
                if((data.body.status == 200) || (data.body.status == 400)) {
                    this.data_processing_message = "Sellpoint edited";
                    if(attr == "delivery"){
                        this.business_details = {};
                    }else{
                        this.manageBusinessDetails = false;
                        //show top
                        this.setComponent("reset-edit","");
                        var top = document.getElementById("top").offsetTop;
                        window.scrollTo(0, top); 
                        this.deactivate_processing();
                    }
                    // this.setComponent("reset-edit","");
                }else{
                    this.data_processing_message = "Could not edit details, something went wrong, please try again";
                    this.deactivate_processing();
                }
                
            }).catch((err) => {
                //log it
                this.data_processing_message = "Could not edit details, something went wrong, please try again";
                this.deactivate_processing();
            })
        },

        //delivery
        setOtherOptions(v,o){
            if(v != undefined){
                if(v == "other"){
                    this.other_delivery_option = true;
                    if(o == "edit"){this.edit_other_delivery_option = true;}//for edit
                }
                if(v == "all"){
                    this.delivery_option.business_delivery_other_option = "nill";
                    if(o == "edit"){this.edit_other_delivery_option = false;}//for edit
                    this.other_delivery_option = false;
                }
            }
            
        },

        addDeliveryOption(){
            this.activate_processing();
            var payload = {
                business_delivery_state: this.delivery_option.state,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.delivery_other_option || "nill",
                business_delivery_custom_option: this.delivery_option.delivery_custom_option || "nill",
                business_delivery_option_price: this.delivery_option.delivery_option_price || 0,
                business_id: this.sellpoint.business_id
            }
            if(payload.business_delivery_option_price == 0){
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            }else{
                if((payload.business_delivery_option != 0) || (payload.business_delivery_other_option != "nill")){
                    service.addDeliveryOption(this, payload).then(function(data) {
                        if((data.body.status == 201) || (data.body.status == 200)) {
                            // toastr.success("Sellpoint Delivery Details Added Successfully", 'Success!');
                            this.sellpoint.business_delivery_options = data.body.data;
                            this.custom_delivery_option = false;
                            this.delivery_option = {};
                            this.business_details = {};
                            this.deactivate_processing();
                        }
                    }).catch((err) => {
                        //log it
                        this.delivery_option = {};
                        this.deactivate_processing();
                    })
                }else{
                    this.data_processing_message = "Select a delivery option";
                    this.deactivate_processing();
                }
            }
            
        },

        editDeliveryOption(){
            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                // business_delivery_state: this.delivery_option.business_delivery_state || this.delivery_option.business_delivery_state_id,
                business_delivery_state: this.delivery_option.business_delivery_state_id,
                business_delivery_city: this.delivery_option.city || 0,
                business_delivery_other_option: this.delivery_option.business_delivery_other_option || "nill",
                business_delivery_custom_option: this.delivery_option.business_delivery_custom_option || "nill",
                business_delivery_option_price: this.delivery_option.business_delivery_option_price || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            }
            //this.delivery_option.business_id = this.sellpoint.business_id;
            if(payload.business_delivery_option_price == 0){
                this.data_processing_message = "Delivery Charge not Added";
                this.deactivate_processing();
            }else{
                if((payload.business_delivery_option != 0) || (payload.business_delivery_other_option != "nill")){
                    service.editDeliveryOption(this, payload).then(function(data) {
                    if(data.body.status == 200) {
                        // toastr.success("Sellpoint Delivery Details edited",'Success!');
                        this.sellpoint.business_delivery_options = data.body.data;
                        this.delivery_option.edit_set = false;
                        this.business_details = {};
                        // this.editDeliveryInformation = false;
                        //this.delivery_option = {};
                        this.deactivate_processing();
                    }
                    }).catch((err) => {
                        //log it
                        //this.delivery_option = {};
                        this.delivery_option.edit_set = false;
                        this.deactivate_processing();
                    })
                }else{
                   this.data_processing_message="Select a delivery option";
                   this.deactivate_processing();
                }
            }
        },
    
        deleteDeliveryOption(id){
            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id
            }
            service.deleteDeliveryOption(this, id, payload).then(function(data) {
                if(data.body.status == 200) {
                    // toastr.success("Sellpoint Delivery Details deleted",'Success!');
                    this.sellpoint.business_delivery_options = data.body.data;
                    this.delivery_option.edit_set = false;
                    this.delivery_option = {};
                    this.business_details = {};
                    this.deactivate_processing();
                }
            }).catch((err) => {
                //log it
                this.delivery_option = {};
                this.deactivate_processing();
            })
        },
        
        addtoProcessingFee(){
            this.activate_processing();
            //post order request
            var payload ={
                order_type: 1, //processing fee
                order_user: this.user.user_id,
                order_business:this.sellpoint.business_id,
                order_amount:this.processing_fee.amount,
                order_service:"Add to Processing Fee Balance",
            }
        
            service.postBusinessGeneralOrders(this, payload).then(function(data) {
                if(data.body.status == 201) {
                    this.app_orders = data.body.data;
                    this.data_processing_message = "Processing Request";
                    this.processPayment();
                }
            }).catch((err) => {
                //log it
            })
        },

        //after payment is received
        postBusinessProcessingFeeTransaction(payment_ref){
            this.data_processing_message = "Adding Processing Fee"
            //post order request
            var payload = {
                processing_fee_transaction_type: 1, //processing fee addto balance
                processing_fee_transaction_amount:this.processing_fee.amount,
                pay_ref:payment_ref,
                business:this.sellpoint.business_id,
            }
        
            service.postBusinessProcessingFeeTransactions(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.processing_fee_transactions = data.body.data;
                    this.sellpoint.business_processing_fee_balance = data.body.data_processing_fee_balance;
                    this.sellpoint.business_processing_fee_debt = data.body.data__processing_fee_debt;
                    this.app_orders = {}; //empty
                    this.data_processing_message = "Processed";
                    this.setMenuTabInnerView('setProcessingFees');
                    this.deactivate_processing();
                    this.processing_fee = {};
                }
            }).catch((err) => {
                //log it
            })
        },

        //set bank details
        setBankDetails(){
            this.activate_processing();
            var payload ={
                business_bank_name: this.sellpoint.business_bank_details.bank_name,
                business_bank_account_name: this.sellpoint.business_bank_details.bank_account_name,
                business_bank_account_number: this.sellpoint.business_bank_details.bank_account_number,
                business_id:this.sellpoint.business_id,
                //more bank settings
                business_bank_rvpay_sync:this.sellpoint.business_bank_details.bank_rvpay_sync || 0,
                business_bank_rvpay_subaccount_id:this.sellpoint.business_bank_details.bank_rvpay_subaccount_id || 0,
                business_bank_rvpay_id:this.sellpoint.business_bank_details.bank_rvpay_id || 0,
                business_bank_rvpay_date_created:this.sellpoint.business_bank_details.bank_rvpay_date_created || 0,
                //new for updates
                business_contact_email:this.sellpoint.business_contact_email,
                business_contact_phone:this.sellpoint.business_contact_phone,
            }
        
            service.setBusinessBankDetails(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.data_processing_message = "Bank Details Set";
                    this.deactivate_processing();
                }
                // this.set_bank_details = false;
            }).catch((err) => {
                //log it
            })
        },

        setBankDetailsRavePay(){
            this.activate_processing();
            this.data_processing_message = "Verifying your bank details...";
            let payload = {
                "account_bank": this.ravepay_sba.account_bank,//,"044"
                "account_number": this.ravepay_sba.account_number,//"0690000023", //this.ravepay_sba.account_bank
                "business_name":  this.sellpoint.business_name,
                "business_email": this.sellpoint.business_contact_email,
                "business_contact": this.sellpoint.business_name,
                "business_contact_mobile": this.sellpoint.business_contact_phone,
                "business_mobile": this.sellpoint.business_contact_phone,
                "country": "NG",
                "meta": [{"metaname": "AFPID", "metavalue": ""}],
                "seckey": service.ravepay_secret_test
            }
            service.createRavepaySubaccount(payload).then(response => {
                if(response.status == 200) {
                    this.data_processing_message = "Bank Details Set";
                    //then set bank details
                    this.sellpoint.business_bank_details.bank_rvpay_sync = 1;
                    this.sellpoint.business_bank_details.bank_rvpay_subaccount_id = response.data.data.subaccount_id;
                    this.sellpoint.business_bank_details.bank_rvpay_id = response.data.data.account_bank;
                    this.sellpoint.business_bank_details.bank_rvpay_date_created = response.data.data.date_created;
                    this.sellpoint.business_bank_details.bank_name = response.data.data.bank_name;
                    this.sellpoint.business_bank_details.bank_account_name = response.data.data.fullname;
                    this.sellpoint.business_bank_details.bank_account_number = response.data.data.account_number;
                    
                    this.setBankDetails();
                    this.deactivate_processing();
                }else{
                    this.data_processing_message = "Could not verify your details, please confirm your details and try again";
                    this.deactivate_processing();
                }
            }).catch((err) => { 
                this.data_processing_message = "Could not verify your details, please confirm your details and try again";
                this.deactivate_processing();
            })
        },

        //set commissions
        setBusinessAgentCommissions(){
            this.activate_processing();
            if(!(this.sellpoint.business_agent_commission <= 100)){
                this.data_processing_message = "value inappropriate";
            }
            else{
                //post order request
                var payload = {
                    business_agent_commission:this.sellpoint.business_agent_commission || 0,
                    business:this.sellpoint.business_id,
                }
            
                service.setBusinessAgentCommissions(this, payload).then(function(data) {
                    // if(data.body.status == 200) {
                        this.data_processing_message = "Processed";
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                        
                    // }
                }).catch((err) => {
                    //log it
                })
            }
        },

        //processing fee switch
        switchProcessingFee(to){
            this.activate_processing();
            var payload ={
                business_process_fee_pay: to,
                business_id:this.sellpoint.business_id
            }
        
            service.switchProcessingFeePay(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.data_processing_message = "Processing Fee Set";
                    this.sellpoint.business_processing_fee_pay_status = to;
                    this.deactivate_processing();
                }
            }).catch((err) => {
                //log it
            })
        },
        

        //set shipping fee status
        setShippingFeeStatus(status_value){
            this.activate_processing();
            this.business_set_shipping_fee_status = status_value;
            var payload ={
                business_set_shipping_fee_status: this.business_set_shipping_fee_status,
                business_id:this.sellpoint.business_id
            }
        
            service.setShippingFeeStatus(this, payload).then(function(data) {
                // if(data.body.status == 200) {
                    // toastr.success("Shipping Fee Ordering Set", 'Reset!');
                    this.sellpoint.business_set_shipping_fee_status = this.business_set_shipping_fee_status;
                    this.deactivate_processing();
                // }
            }).catch((err) => {
                //log it
            })
        },
        //.../delivery

        //coupons and discounts
        //set coupons and discount
        setDiscountsAndCoupons(){
            this.activate_processing();
            this.data_processing_message = "";
            //settings for product and producitems
            if(this.product_details.setProductDiscount || this.product_details.setProductItemDiscount){
                this.discount_coupon.discount_category = 1;  //HACK..TO LET GO ../ASSIGNED 1 instead of 0.
            }
            
            //validate entry
            let entry_arr = [
                ["Discount or Coupon",this.discount_coupon.is_discount_coupon,"str"],
                ["Coupon Percentage",this.discount_coupon.discount_percentage,"num"],
                ["Discount Category",this.discount_coupon.discount_category,"num"],
                ["Start Date",this.discount_coupon.discount_start_date,"date"],
                ["End Date",this.discount_coupon.discount_end_date,"date"]
            ];
            let validated_arr = validator.validate_array(entry_arr,"Please fill in ");
            if(validated_arr.length == 0){
                //check if end date is greater than start date
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date)
                if(end_date <= start_date){
                    this.data_processing_message = "Please reset Dates, End Date should be greater than Start Date";
                    this.deactivate_processing();
                }else{
                    //set for business category
                    let discount_category  = 0;
                    if(this.business_details.setDiscount){
                        discount_category = this.discount_coupon.discount_category;
                    }

                    //set for product and product items
                    let product_id = 0;
                    let product_item_id = 0;
                    
                    if(this.product_details.setProductDiscount || this.product_details.setProductItemDiscount){
                        product_id = this.product.product_id;
                    }
                    if(this.product_details.setProductItemDiscount){
                        product_item_id = this.product_item.product_item_id;
                    }
                    //set for product and product items

                    var payload = {
                        business_id: this.sellpoint.business_id,
                        business_market: service.apiToken,
                        product_id: product_id,
                        product_item_id: product_item_id,
                        is_coupon_or_discount: this.discount_coupon.is_discount_coupon || 'C', //or coupon
                        coupon_business_category:discount_category,
                        coupon_percentage: this.discount_coupon.discount_percentage,
                        coupon_min_quantity: this.discount_coupon.discount_min_quantity,
                        coupon_start_date: this.discount_coupon.discount_start_date,
                        coupon_end_date: this.discount_coupon.discount_end_date,
                    }
                    service.setDiscountsAndCoupons(this, payload).then(function(data) {
                        if(data.body.status == 201) {
                            // toastr.success("New Discount Set", 'Update!');
                            // this.sellpoint.business_discounts_coupons = data.body.data;
                            this.business_details.setDiscount = false;
                            this.business_details.viewDiscounts = true;
                            if(this.product_details.setProductDiscount || this.product_details.setProductItemDiscount){
                                let res = data.body.data;
                                for(let item of this.product.product_items){
                                    for(let row of res){
                                        if(row.product_item_id == item.product_item_id){
                                            item.product_item_discounts = row.product_item_discounts;
                                        }
                                    }
                                    // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                                }
                                if(this.product_details.setProductDiscount){
                                    this.product.product_only_coupon_discount_count++;
                                }
                                if(this.product_details.setProductItemDiscount){
                                    this.product_item.product_item_only_coupon_discount_count++;
                                }
                            }else{
                                this.sellpoint.business_discounts_coupons = data.body.data; 
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch((err) => {
                        //log it
                        this.deactivate_processing();
                    })
                }//date reset check
            }else{
                validated_arr.forEach(function(error) {
                    // toastr.error(error); 
                    this.data_processing_message =  this.data_processing_message + " . " +error;
                }, this);
                this.deactivate_processing();
            }
            
        },

        // edit coupons and discount
        editDiscountsAndCoupons(){
            this.data_processing_message = "";
            //validate entry
            let entry_arr = [
                ["Coupon Percentage",this.discount_coupon.discount_percentage,"num"],
                ["Discount Category",this.discount_coupon.discount_category,"num"],
                ["Start Date",this.discount_coupon.discount_start_date,"date"],
                ["End Date",this.discount_coupon.discount_end_date,"date"]
            ];
            let validated_arr = validator.validate_array(entry_arr,"Please fill in ");
            if(validated_arr.length == 0){
                //check if end date is greater than start date
                var start_date = new Date(this.discount_coupon.discount_start_date);
                var end_date = new Date(this.discount_coupon.discount_end_date);
                if(end_date <= start_date){
                    this.data_processing_message = "Please reset Dates, End Date should be pass Start Date";
                    this.deactivate_processing();
                }else{
                    this.activate_processing();
                    this.discount_coupon.business_id = this.sellpoint.business_id;
                    this.discount_coupon.business_market = service.apiToken;
                    service.editDiscountsAndCoupons(this, this.discount_coupon).then(function(data) {
                        if(data.body.status == 200) {
                            // toastr.success("Discount Set", 'Update!');
                           // this.sellpoint.business_discounts_coupons = data.body.data;
                            this.discount_coupon = {};
                            this.business_details.viewDiscounts = true;
                            if(this.product_details.setProductDiscount || this.product_details.setProductItemDiscount){
                                let res = data.body.data;
                                for(let item of this.product.product_items){
                                    for(let row of res){
                                        if(row.product_item_id == item.product_item_id){
                                            item.product_item_discounts = row.product_item_discounts;
                                        }
                                    }
                                    // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                                }
                            }else{
                                this.sellpoint.business_discounts_coupons = data.body.data; 
                            }
                            this.deactivate_processing();
                            this.product_details = {};
                        }
                    }).catch((err) => {
                        //log it
                        this.deactivate_processing();
                    })
                }
            }else{
                validated_arr.forEach(function(error) {
                    // toastr.error(error); 
                    this.data_processing_message =  this.data_processing_message + " . " +error;
                }, this);
                this.deactivate_processing();
            }
        },

        
        // edit coupons and discount
        deactivateDiscountsAndCoupons(payload){
            this.activate_processing();
            payload.business_id = this.sellpoint.business_id;
            payload.business_market = service.apiToken;
            service.deactivateDiscountsAndCoupons(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    // toastr.success("Discount Set", 'Update!');
                    // this.sellpoint.business_discounts_coupons = data.body.data;
                    this.business_details.viewDiscounts = true;
                    if(this.product.product_id){
                        let res = data.body.data;
                        for(let item of this.product.product_items){
                            for(let row of res){
                                if(row.product_item_id == item.product_item_id){
                                    item.product_item_discounts = row.product_item_discounts;
                                }
                            }
                            // item.product_item_discounts = res.filter(function(discount){ return discount.discount_product_item == item.product_item_id;});
                        }
                    }else{
                        this.sellpoint.business_discounts_coupons = data.body.data; 
                    }
                    this.deactivate_processing();
                    this.product_details = {};
                }
            }).catch((err) => {
                //log it
                this.deactivate_processing();
            })
        },

        //../coupons and discounts

        //business rewards
        getBusinessRewardSettings(){
            service. getBusinessRewardSettings(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint.reward_settings = response.body.data;
                }
            }).catch((err) => {
                //console.log(err)
            })
        },

        postBusinessRewardSettings(reward_type){
            this.activate_processing();
            var payload = {
                reward_type_business: this.sellpoint.business_id,
                reward_type_type: reward_type.reward_type_id,
                reward_type_amount_type: this.set_reward_type_amount_type || C, //default cash
                reward_type_amount: this.business_details.set_reward_type_amount || 5,
                reward_type_duration: this.business_details.set_reward_type_duration || 0,
            }
            if(payload.reward_type_amount == 0){
                this.data_processing_message = "Amount should be more than 0";
                this.deactivate_processing();
            }else{
                service.postBusinessRewardSettings(this, payload).then(function(data) {
                    if((data.body.status == 201) || (data.body.status == 200)) {
                        this.sellpoint.reward_settings = data.body.data;
                        this.data_processing_message = "Set";
                        this.business_details = {};
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                }).catch((err) => {
                    //log it
                    this.business_details = {};
                    this.deactivate_processing();
                })
            }
            
        },

        updateBusinessRewardSettings(reward_type_setting){
            this.activate_processing();
            var payload = {
                reward_set: reward_type_setting.reward_set,
                reward_set_amount_type: reward_type_setting.reward_set_amount_type || C, //default cash
                reward_set_amount: reward_type_setting.reward_set_amount || 5,
                reward_set_duration: reward_type_setting.reward_set_duration || 0,
            }
            if(payload.reward_set_amount == 0){
                this.data_processing_message = "Amount should be more than 0";
                this.deactivate_processing();
            }else{
                service.updateBusinessRewardSettings(this, payload).then(function(data) {
                    if((data.body.status == 201) || (data.body.status == 200)) {
                        this.sellpoint.reward_settings = data.body.data;
                        this.data_processing_message = "Updated";
                        this.business_details = {};
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                }).catch((err) => {
                    //log it
                    this.business_details = {};
                    this.deactivate_processing();
                })
            }
        },

        onFileChangeBannerImage(e,type) {
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', this.sellpoint.business_id); 
                formData.append('data_type', type); 
                service.uploadBusinessDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == "business_banner_image"){
                            this.sellpoint.business_banner_image = data.body.data;
                            this.set_gallery_banner_image = this.sellpoint.business_banner_image;
                        }
                        if(type == "business_brand_image"){
                            this.sellpoint.business_brand_image = data.body.data;
                        }
                        //wait and reset
                        let self = this;
                        setTimeout(function(){ 
                            //close the sidebar after one sec
                            self.deactivate_processing();
                            //load a bit more to set the image
                            self.loading = true;
                            setTimeout(function(){ 
                                self.loading = false;
                            }, 1200);
                        }, 1000);
                        // this.deactivate_processing();
                    }else{
                        this.data_error_message = "Could not update, something went wrong. Please try again";
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    this.data_error_message = "Could not update, something went wrong. Please try again";
                    this.deactivate_processing();
                })
            }   
                
        },
        //../...business--settings
        
        //.....product--settings------/
        addProduct(){
            this.resetMessages(); //reset
            this.activate_processing();
            // this.loading = true;
            var credentials = {
                product_name: this.product.product_name,
                product_is_product_or_service: this.is_product_service,
                product_category_is_set: this.category.business_category_id || 0,
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                // product_item_price: this.product.product_item_price.replace(/\D+/g, ''),/^[0-9.,]+$/
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            }
            
            let navi = this.$router;
            if(credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";
                        
                        // this.product = data.body.data; //to avoid force form input resets
                        let product = data.body.data;
                        
                        //add image
                        // this.imageForm.append("data_id", this.product.product_id);
                        this.imageForm.append("data_id", product.product_id);
                        // this.imageForm.append("data_type","product_items"); //refac
                        this.imageForm.append("data_type","products");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                            if(data.body.status == 200){
                                this.setBusinessComponent('viewBusinessCategory',this.sellpoint,this.category);
                                this.deactivate_processing();
                                this.resetFormData()
                            }else{
                                this.data_processing_message = service.upload_media_error_msg;
                                // this.deactivate_processing();
                                //reset after timed out warning
                                setTimeout(function(){  
                                    self.setBusinessComponent('viewBusinessCategory',self.sellpoint,self.category);
                                    self.deactivate_processing();
                                    self.resetFormData();
                                }, service.timeout_msg_wait_period); 
                            }
                        }).catch((err) => {
                            if(err) {}
                            this.data_error_message = service.upload_media_error_msg;
                            this.deactivate_processing();
                            this.resetFormData();
                        })

                        //if uploading takes time continue with calls in the kipper
                        let self = this;
                        setTimeout(function(){  
                            self.setBusinessComponent('viewBusinessCategory',self.sellpoint,self.category);
                            self.deactivate_processing();
                            self.resetFormData();
                        }, service.upload_wait_period); //wait and call posts in gallery

                    }
                }).catch((err) => {
                    if(err) {
                        this.data_error_message = "Something went wrong, preparing report ...";
                        this.deactivate_processing();
                    }
                })
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields ...";
                this.deactivate_processing();
            }
        },

        addNewAgentProduct(product,add_to_agent_category_type){
            this.product = product;
            this.activate_processing(); 
            //add more product attributes before  sending across
            product.product_agent_business = this.sellpoint.business_id;
            product.product_agent_category = this.category.business_category_id;
            product.product_agent_category_type = add_to_agent_category_type;
            
            let navi = this.$router;
            // if(credentials.product_name != undefined) {
                service.addAgentProduct(this, product).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_success_message = "Processing, please wait ...";
                        this.deactivate_processing = "";
                    }
                }).catch((err) => {})
            // }
        },

        
        //images
        getProductImages(){
            service.getProductImages(this,this.product.product_id).then(response => {
                if(response.body.status == 200) {
                    this.product.product_images = response.body.data;
                    this.product_display_image = this.product.product_images[0];
                    //reset if set
                    this.data_media_error_message = "";
                    this.deactivate_processing();
                }
            }).catch((err) => {})
                
        },

        deleteProductImage(image){
            this.activate_processing();
            service.deleteProductImage(this, image).then(function(data) {
                if(data.body.status == 200) {
                    this.getProductImages();
                }
                this.deactivate_processing();
            }).catch((err) => {this.deactivate_processing();})
        },
        //images
        //edit product
        editProduct(){
            this.activate_processing();
            //this.business.agree = true;
            //some settings
            let set_product_category = this.product.product_category_id;
            if((this.product.product_sub_category != undefined) || (this.product.product_listed_category != undefined)){ //if either of 2 where selected
                set_product_category = 0; //make product_category 0
            }else{
                if(this.product.product_category != undefined){ //if new product_category is selected
                    set_product_category = this.product.product_category;
                }else{
                    set_product_category = this.product.product_category_id; //current product_category
                }
            }
            var credentials = {
                product_id: this.product.product_id,
                product_name: this.product.product_name,
                // product_category: this.product.product_category || this.product.product_category_id, //before

                //new
                product_category: set_product_category,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                //

                product_url_name: this.product.product_url_name,
                product_description: this.product.product_description || "nill",
                product_business: this.product.product_business_id, //new to help with category settings
            }
            
            let navi = this.$router;
            if(credentials.product_name != undefined) {
                service.editProduct(this, this.product.product_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        //toastr.success("Product Updated", 'Success!');
                        this.product = response.body.data;
                        this.product_details = {};
                        // navi.push("/"+this.product.product_business_ownername+"/"+this.product.product_url_name);
                    }else{
                        this.product_details = {};
                        this.deactivate_processing();
                    }
                }).catch((err) => {
                    if(err) {
                        //toastr.warning("Something went wrong", 'Warning!'); 
                        this.data_processing_message = "Something went wrong";
                        this.product_details = {}; //manage with this for now
                        this.deactivate_processing();
                    }
                })
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_processing_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },

        editProductSingleProductItem(){
            this.activate_processing();
            //quick check for product item
            let set_product_item = 0;
            let current_set_product_item_actual_price = this.product.product_items[0].product_item_actual_price;
            if(this.product.product_items[0].product_item_actual_price != 0){
                set_product_item = this.product.product_items[0].product_item_actual_price;
            }else{
                set_product_item = this.product.product_items[0].product_item_price;
            }
            var credentials = {
                product_item_id: this.product.product_items[0].product_item_id,
                // product_item_price: this.product_item.product_item_price,
                product_item_price: set_product_item,
                product_item_weight: this.product.product_items[0].product_item_weight || 1,
                product_item_quantity: this.product.product_items[0].product_item_quantity || 10
            }
    
            let navi = this.$router;
            if(credentials.product_item_price != undefined) {
                service.editProductItemSingle(this, this.product.product_items[0].product_item_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        this.product.product_items[0] = response.body.data;
                        this.product.product_items[0].product_item_actual_price = current_set_product_item_actual_price; //rehack later
                        this.deactivate_processing();
                        this.product_details = {};
                    }
                }).catch((err) => {
                        if(err) {
                            this.data_processing_message = "Update failed, Something went wrong";
                           this.deactivate_processing();
                        }
                    })
                }else {
                    this.data_processing_message = 'Kindly fill all fields';
                    this.deactivate_processing();
                }
        },

        //edit product
        editProductSettings(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_groups_set_name: this.product.product_groups_set_name || 'Group/Types',
                product_groups_items_set_name: this.product.product_groups_items_set_name || 'Select Item',
            }
            
            let navi = this.$router;
            service.editProductSettings(this, this.product.product_id, payload).then(response => {
                if(response.body.status == 200) {
                    this.product = response.body.data;
                    this.product_details = {};
                }else{
                    this.product_details = {};
                    this.deactivate_processing();
                }
            }).catch((err) => {
                if(err) {
                   this.data_processing_message = "Something went wrong";
                    this.product_details = {}; //manage with this for now
                    this.deactivate_processing();
                }
            })
        },

        addProductItem(){
            this.activate_processing();
            if(this.product_details.addProductItemToGroup){
                var credentials = {
                    product_item_group: this.product_item_group.product_item_group_id || 1, //default add to ist group
                    
                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: (this.product.product_item_service_duration + this.service_duration) || '1 year',
                }
            }else{
                let new_product_item_group = false;
                let product_item_group_is_color_image = 'IMG';
                if(this.product.product_item_group == undefined){
                    new_product_item_group = true;
                }
                if(this.product.product_item_group_color == undefined){
                    product_item_group_is_color_image = 'IMG';
                }else{
                    product_item_group_is_color_image = 'COL';
                    // this.product.product_item_group_color = '#000000';
                }
                var credentials = {
                    //new product_items_group_details
                    product_new_product_item_group: new_product_item_group,
                    product_item_group_product: this.product.product_id,
                    product_item_group_name: this.product.product_item_group_name || "Group/Type",
                    product_item_group_is_color_image: product_item_group_is_color_image,
                    product_item_group_color: this.product.product_item_group_color || "Nill",
                    product_item_group_image: this.product.product_item_group_image || 0,
                    //./..new .product_items_group_details
                    
                    product_item_group: this.product.product_item_group || 1, //default add to ist group
                    
                    product_id: this.product.product_id,
                    product_item_price: this.product.product_item_price,
                    product_item_weight: this.product.product_item_weight || 1,
                    product_item_quantity: this.product.product_item_quantity || 1,
                    product_item_size: this.product.product_item_size || "Nill",
                    product_item_service_tag: this.product.product_item_service_tag || "Nill",
                    product_item_service_duration: (this.product.product_item_service_duration + this.service_duration) || '1 year',
                }
            }
            let navi = this.$router;
            if(credentials.product_item_price != undefined) {
                service.addProductItem(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_success_message = "Product Item Added Successfully";
                        //this.product = data.body.data_product;
                        this.reloadToView()
                        // this.product_details.addProductItemPanel = false;
                        // this.product_details = {};
                        //this.setComponent('reset-edit','');
                    }
                }).catch((err) => {
                    if(err) {
                        this.data_error_message = "Something went wrong"; 
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        //  console.log(err)
                        // this.disable_btn = false;
                        this.deactivate_processing();
                    }
                })
            }else {
                this.data_error_message = "Kindly fill all fields"; 
                // toastr.error('Kindly fill all fields', 'Warning!');
                // this.disable_btn = false;
                this.deactivate_processing();
            }
        },

        //edit product item
        editProductItem(){
            this.activate_processing();
            //quick check for product item
            let set_product_item = 0;
            if(this.product_item.product_item_actual_price != 0){
                set_product_item = this.product_item.product_item_actual_price;
            }else{
                set_product_item = this.product_item.product_item_price;
            }
            var credentials = {
                product_item_id: this.product_item.product_item_id,
                // product_item_price: this.product_item.product_item_price,
                product_item_price: set_product_item,
                product_item_weight: this.product_item.product_item_weight || 1,
                product_item_size: this.product_item.product_item_size || "Nill",
                product_item_service_tag: this.product_item.product_item_service_tag || "Nill",
                product_item_quantity: this.product_item.product_item_quantity || 10
            }
    
            let navi = this.$router;
            if(credentials.product_item_price != undefined) {
                service.editProductItem(this, this.product_item.product_item_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        this.product_item = response.body.data;
                        this.deactivate_processing();
                        this.product_details = {};
                    }
                }).catch((err) => {
                        if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                           // console.log(err)
                           this.data_processing_message = "Update failed, Something went wrong";
                           this.deactivate_processing();
                        }
                    })
                }else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_processing_message = 'Kindly fill all fields';
                    this.deactivate_processing();
                }
        },

        //edit product item group
        editProductItemGroup(){
            this.activate_processing();
            let product_item_group_is_color_image = 'IMG';
            if(this.product_item_group.product_item_group_color == undefined){
                product_item_group_is_color_image = 'IMG';
            }else{
                product_item_group_is_color_image = 'COL';
            }

            //set only color if defined
            if(this.product_item_group.product_item_group_color_new != undefined){
                product_item_group_is_color_image = 'COL';
                this.product_item_group.product_item_group_color = this.product_item_group.product_item_group_color_new; //a new one
                this.product_item_group.product_item_group_image = 0; //set image to 0
            }else{
                product_item_group_is_color_image = 'IMG';
                this.product_item_group.product_item_group_color = "Nill"; //set color to nill
            }
            var credentials = {
                product_item_group_product: this.product.product_id,
                product_item_group_name: this.product_item_group.product_item_group_name || "Type",
                product_item_group_is_color_image: product_item_group_is_color_image,
                product_item_group_color: this.product_item_group.product_item_group_color || "Nill",
                product_item_group_image: this.product_item_group.product_item_group_image || 0,
            }


           let navi = this.$router;
            if(credentials.product_item_group_name != undefined) {
                service.editProductItemGroup(this, this.product_item_group.product_item_group_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        //this.product_item_group = response.body.data;

                        this.product.product_item_groups = response.body.data;

                        this.deactivate_processing();
                        this.product_details = {};
                    }else{
                        this.deactivate_processing();
                        this.product_details = {};
                    }
                }).catch((err) => {
                        if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                           // console.log(err)
                           this.data_processing_message = 'Update failed, Something went wrong';
                           this.deactivate_processing();
                        }
                    })
                }else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_processing_message = 'Kindly fill all fields';
                    this.deactivate_processing();
                }
        },

        restockProductItem(){
            this.activate_processing();
            //quick check for product item
            let set_product_item = 0;
            if(this.product_item.product_item_actual_price != 0){
                set_product_item = this.product_item.product_item_actual_price;
            }else{
                set_product_item = this.product_item.product_item_price;
            }
            var credentials = {
                product_item: this.product_item,
                product_item_id: this.product_item.product_item_id,
                product_item_quantity_restock: this.product_item.product_item_quantity_restock || 10
            }
    
            let navi = this.$router;
            if(credentials.product_item_quantity_restock != undefined) {
                service.restockProductItem(this, this.product_item.product_item_id, credentials).then(response => {
                    if(response.body.status == 200) {
                        this.product_item = response.body.data;
                        this.deactivate_processing();
                        this.product_details = {};
                    }
                }).catch((err) => {
                        if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                           // console.log(err)
                           this.data_processing_message = "Update failed, Something went wrong";
                           this.deactivate_processing();
                        }
                    })
            }else {
                //toastr.error('Kindly fill all fields', 'Warning!');
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },

        removeProduct(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id
            }
            let navi = this.$router;
            service.removeProduct(this,this.product.product_id,payload).then(response => {
                if(response.body.status == 200) {
                    location.reload(true)
                    // this.deactivate_processing();
                }
            }).catch((err) => {
                if(err) {
                    location.reload(true)
                }
            })
            
        },

        removeProductItem(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_id: this.product_item.product_item_id
            }
            let navi = this.$router;
            service.removeProductItem(this,this.product_item.product_item_id,payload).then(response => {
                if(response.body.status == 200) {
                    if(response.body.no_product){
                        this.redir(this.$route.params.id); //go to sellpoint
                    }
                    this.product.product_item_groups = response.body.data;
                   // location.reload(true)
                    //this.product.product_item = response.body.data;
                    //maually delete from array
                    //product_item_group.product_items.splice(this.product_item.product_item_id, 1 );
                    this.deactivate_processing();
                    this.removeItemPanel = false;
                }
            }).catch((err) => {
                if(err) {
                    //console.log(err)
                    this.deactivate_processing();
                }
            })
            
        },

        removeProductItemGroup(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_item_group_id: this.product_item_group.product_item_group_id
            }
            let navi = this.$router;
            service.removeProductItemGroup(this,this.product_item_group.product_item_group_id,payload).then(response => {
                if(response.body.status == 200) {
                    if(response.body.no_product){
                        this.redir(this.$route.params.id); //go to sellpoint
                    }
                    this.product.product_item_groups = response.body.data;
                    this.deactivate_processing();
                    this.removeItemGroupPanel = false;
                }
            }).catch((err) => {
                if(err) {
                    //console.log(err)
                    this.deactivate_processing();
                }
            })
            
        },

        setProductDelivery(){
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_delivery_details: this.product.product_delivery_returns
            }
            service.setProductDelivery(this, 1, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.product_details = {}
                }
                this.deactivate_processing();
            }).catch((err) => {
                //log it
                this.product_details = {}
                this.deactivate_processing();
            })
        },

        setProductShippingFeeStatus(){
            this.set_shipping_fee_status_track = true;
            this.activate_processing();
            var payload = {
                product_id: this.product.product_id,
                product_set_shipping_fee_status: this.product_set_shipping_fee_status,
            }
            service.setProductShippingFeeStatus(this, payload).then(function(data) {
                // if(data.body.status == 200) {
                    this.product.product_set_shipping_fee_status = this.product_set_shipping_fee_status;
                    this.set_shipping_fee_status_track = false;
                    this.deactivate_processing();
                // }
            }).catch((err) => { 
                //log it
            })
        },

        setProductDeliveryOption(){
            this.activate_processing();
            var payload = {
                business_id: this.sellpoint.business_id,
                business_product_id: this.product.product_id,
                business_product_delivery_fee: this.delivery_option.product_delivery_fee || 0,
                business_delivery_option_id: this.delivery_option.business_delivery_option_id
            }
            if(payload.business_product_delivery_option_price == 0){
                toastr.warning("Delivery Charge not Added", 'Warning!');
            }else{
                if((payload.business_product_delivery_option != 0)){
                    service.setProductDeliveryOption(this, payload).then(function(data) {
                    if((data.body.status == 200) || (data.body.status == 201)) {
                       // toastr.success("Sellpoint Delivery Details edited",'Success!');
                        // this.product.product_delivery_options = data.body.data;
                        this.product.product_business_delivery_options = data.body.data;
                        this.delivery_option.edit_set = false;
                        this.product_details = {};
                        //this.delivery_option = {};
                        this.deactivate_processing();
                    }else{
                        this.deactivate_processing();
                    }
                    }).catch((err) => {
                        //log it
                        //this.delivery_option = {};
                        this.delivery_option.edit_set = false;
                        this.product_details = {};
                        this.deactivate_processing();
                    })
                }else{
                    //toastr.warning("Select a delivery option", 'Warning!');
                    this.deactivate_processing();
                }
            }
        },

        //---./product-settings---------/

        //---order---settings-------/
        getAppBusinessOrders(){
            service.getAppBusinessOrders(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_orders = response.body.data;
                    this.sellpoint.orders = response.body.data;
                    // this.componentOrdersKey++;
                    // console.log(this.sellpoint.orders)
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },

        updateOrderPayment(order) {
            var payload = {
                 payment_orders: order,
                 payment_update_type:"manualUpdateConfirmation",
             }
             let navi = this.$router;
             service.updatePayment(this, payload).then(data => {
                 if(data.body.status == 200) {
                     //return order id if one and navigate with it to orders
                     this.data_processing_message = "Order Confirmed"
                     this.order = data.body.data;
                 }else {
                    this.data_processing_message = "Sorry, could not update payment";
                 }
             }).catch((err) => {
                 if(err) {
                    // console.log(err)
                    this.data_processing_message = "Sorry, could not process information";
                 }
             })
             
        },

        updateOrders(order,status) {
            var payload = {
                order: order,
                order_status:status,
            }
            let navi = this.$router;
            service.updateOrders(this, payload).then(data => {
                if(data.body.status == 200) {
                    //return order id if one and navigate with it to orders
                    this.data_processing_message = "Order Updated";
                    // console.log("0here");
                    // console.log(data.body.data);
                    this.order = data.body.data;
                }else {
                    this.data_processing_message = "Sorry, could not update payment";
                }
            }).catch((err) => {
                if(err) {
                    // console.log(err)
                    this.data_processing_message = "Sorry, could not process information";
                }
            })
        },
        //-----./order---settings-------/

        //---transactions---settings----/
        getAppBusinessTransactions(){
            service.getAppBusinessTransactions(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.sellpoint_transactions.transactions = response.body.data;
                    this.sellpoint_transactions.transactions_total = response.body.data_total;
                    this.sellpoint_transactions.transactions_total_amount = response.body.data_total_amount;
                    this.sellpoint_transactions.transactions_total_today = response.body.data_total_today;
                    this.sellpoint_transactions.transactions_total_today_amount = response.body.data_total_today_amount;
                }
            }).catch((err) => { })
        },
        //---transactions---settings---/

        //--------posts-----xposts------settings------/
        setNewPost(post_type,post_type_name){
            this.post = {}; //refresh
            this.post.post_products = []; //initialise
            this.post.selected_post_products = []; //initialise //for hold
            this.post.post_temp_id = Math.random(); //for temp purposes
            this.post.post_type = post_type;
            this.post.post_type_name = post_type_name;
            this.setMenuComponent('newBusinessPosts',this.sellpoint,'');
        },
        

        getAppBusinessPosts(){ //2 business
            service.getXPosts(this, 2, this.sellpoint.business_id,0,50).then(response => {
                if(response.body.status == 200) {
                    this.posts = response.body.data;
                }
            }).catch((err) => { })
        },

        setAttachProductToPost(category){
            this.category = category;
            this.getBusinessCategoryProducts();
            this.setMenuTabInnerView('viewProducts');
            this.attachProductsComponentKey++;
        },

        attachProductToPost(product){
            if(product.is_attached_to_post == this.post.post_temp_id){ //use as check for now
                //remove from post_products array
                product.is_attached_to_post = 0;
                const indexa = this.post.post_products.findIndex(p => p === product.product_id); //best removal
                this.post.post_products.splice(indexa, 1);
                const indexm = this.post.selected_post_products.findIndex(p => p.product_id === product.product_id); //best removal
                this.post.selected_post_products.splice(indexm, 1);
            }else{
                product.is_attached_to_post = this.post.post_temp_id;
                this.post.post_products.push(product.product_id);
                this.post.selected_post_products.push(product);
            }
            
            this.attachProductsComponentKey++;
        },
        addNewPost(){
            this.activate_processing();
            //some checks
            if(this.post.post_products.length > 0){this.post_has_products = 1;}else{this.post_has_products = 0;}
            var payload = {
                post_point_type: 2, //business
                post_point: this.sellpoint.business_id,
                post_type: this.post.post_type,
                post_parent: 0,
                post_title: this.post.post_title || "nil",
                post_post: this.post.post_details || "nil",
                post_start_date: this.post.post_start_date || "",
                post_end_date: this.post.post_end_date || "",
                post_product: this.post.post_product || 0,
                post_has_products: this.post_has_products || 0,
                post_products: this.post.post_products || [],
            }
          
            let navi = this.$router;
            if((payload.gallery_post_details != undefined) || (payload.gallery_post_details || 'nil')) {
                service.addXPosts(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Post Created";
                        //log user in
                        // this.post = data.body.data; //dont use for now //to avoid oerriding pre settings
                        this.posts = data.body.data_posts;
                           
                        //add image //images //media  //multilple uploads loops
                        let uploads_count = 0;
                        if(this.imagesFormArray.length > 0){
                            for(let imageForm of this.imagesFormArray){
                                imageForm.append("data_id", this.post.post_id);
                                imageForm.append("data_type","post_media");
                                service.uploadDataPhoto(this, imageForm).then(data => {
                                    if(data.body.status == 200){
                                        uploads_count++;
                                        if(uploads_count == this.imagesFormArray.length){
                                            this.setMenuTabView('setBusinessPosts',this.sellpoint,'');
                                            this.setMenuComponent('viewBusiness',this.sellpoint,'')
                                            this.deactivate_processing();
                                        }
                                    }
                                }).catch((err) => {
                                    this.data_processing_message =  "Media upload may have a problem";
                                    this.deactivate_processing();
                                })
                            }
                        }else{
                            this.setMenuTabView('setBusinessPosts',this.sellpoint,'');
                            this.setMenuComponent('viewBusiness',this.sellpoint,'')
                            this.deactivate_processing();
                        }
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },

        addNewPostNotification(){
            this.activate_processing();
            //some checks
            //img config
            let notification_has_image = 0;
            let notification_image_module = 0;
            let notification_image_module_id = 0;
            let notification_image_col = "";
            if(this.post.post_media && (this.post.post_media.length > 0)){
                notification_has_image = 1;
                notification_image_module = 18; //post media
                notification_image_module_id = this.post.post_media[0].post_media_id;
                notification_image_col = "psm_media";
            }else if(this.post.post_products && (this.post.post_products.length > 0)){
                notification_has_image = 1;
                notification_image_module = 17; //product media
                notification_image_module_id = this.post.post_products[0].product_images[0].product_image_id;
                notification_image_col = "pim_image";
            }

            var payload = {
                notification_custom_header: this.post.post_title,
                notification_custom_message: this.post.post_notification, //business
                notification_custom_url: "posts/"+this.post.post_url_name,
                notification_cta: 4, //New Update
                notification_has_image: notification_has_image,
                notification_image_module: notification_image_module,
                notification_image_module_id: notification_image_module_id,
                notification_image_col: notification_image_col, 
                notification_type: 3, //custom
                notification_module: 6, //posts
                notification_module_id: this.post.post_id,
                market_business: service.apiToken,
                notify_user_id: 0,
                notify_following: 1,
                business_id: this.sellpoint.business_id,
            }
          
            let navi = this.$router;
            if((payload.post_notification != undefined) || (payload.post_notification != '')) {
                service.addNotifications(this, payload).then(function(data) {
                    if(data.body.status == 201) {
                        this.data_processing_message = "Notification Added";
                        // this.posts = data.body.data_posts;
                        this.deactivate_processing();
                        this.setMenuTabInnerView('');
                    }
                }).catch((err) => {
                    this.data_processing_message =  "Something went wrong";
                    this.deactivate_processing();
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },

        //--------./posts-----xposts------settings------/


        //---lookbook-settings---------/
        addPostToGallery(){
            this.disable_btn = true;
            //this.business.agree = true;
            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id, 
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details,
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');
                        //log user in
                        this.post = data.body.data;
                        
                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type","gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                        if(data.body.status == 200){
                            //this.product.product_image = data.body.data;
                            // location.reload(true);
                           // this.product_info = true;
                           this.setGallery();
                           this.gallery = data.body.data_gallery;
                           this.addNewPost = false;
                           this.edit_mode = false;
                            //this.product_url = "/"+this.$route.params.id+"/"+this.product.product_url_name;
                        }
                        }).catch((err) => {
                                if(err) {
                                // log it
                                // console.log(err)
                                }
                            toastr.warning("Something went wrong.", 'Warning!');
                        })

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                        
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.warning("Something went wrong", 'Warning!'); 
                       // console.log(err)
                        this.disable_btn = false;
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },

        editLookbook(){
            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                gallery_group_name: this.lookbook.gallery_posts_group_name,
                gallery_group_description:this.lookbook.gallery_posts_group_text,
                gallery_group_point: this.sellpoint.business_id,
            }
          
            let navi = this.$router;
            if(credentials.gallery_group_name != undefined) {
                service.editGallery(this, this.lookbook.gallery_posts_group_id, credentials).then(function(data) {
                    if(data.body.status == 200) {
                        this.data_processing_message = "Lookbook Edited";
                        //log user in
                       // this.gallery = data.body.data;
                       //reset lookbook
                        this.deactivate_processing();
                        this.lookbook_details = {};

                    }else{
                    this.deactivate_processing();
                    this.editGalleryPanel = false;
                   }
                }).catch((err) => {
                    if(err) {
                       this.data_processing_message = "Something went wrong"; 
                       // console.log(err)
                       this.deactivate_processing();
                       this.lookbook_details = {};
                    }
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.disable_btn = false;
            }
        },

        deleteLookbook(){
            this.activate_processing();
            let navi = this.$router;
            service.deleteGallery(this, this.lookbook.gallery_posts_group_id).then(function(data) {
                if(data.body.status == 200) {
                   //return to sellpoint
                   //location.replace('/'+this.$route.params.id); //go to sellpoint
                  // reset data
                }else{
                    this.data_processing_message = "Something went wrong"; 
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch((err) => {
                if(err) {
                    this.deactivate_processing();
                    this.lookbook_details = {};
                    this.data_processing_message = "Something went wrong";
                   // console.log(err)
                    // this.disable_btn = false;
                }
            })
        },

        
        editLookbookPost(){
            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                gallery_post_caption: this.lookbook_post.gallery_post_caption,
                gallery_post_details:this.lookbook_post.gallery_post_details,
                gallery_post_group: this.lookbook.gallery_posts_group_id,
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_caption != undefined) {
                service.editGalleryPost(this, this.lookbook_post.gallery_post_id, credentials).then(function(data) {
                    if(data.body.status == 200) {
                        this.data_processing_message = "Lookbook Post Edited";
                        //log user in
                       // this.gallery = data.body.data;
                        this.deactivate_processing();
                        this.lookbook_details = {};
                        this.lookbook = data.body.data; //refresh data
                   }else{
                    this.deactivate_processing();
                    this.lookbook_details = {};
                   }
                }).catch((err) => {
                    if(err) {
                        this.data_processing_message = "Something went wrong"; 
                       // console.log(err)
                       this.deactivate_processing();
                       this.lookbook_details = {};
                    }
                })
            }else {
                this.data_processing_message = 'Kindly fill all fields';
                this.deactivate_processing();
            }
        },

        deleteLookbookPost(){
            this.activate_processing();
            let navi = this.$router;
            service.deleteGalleryPost(this, this.lookbook_post.gallery_post_id).then(function(data) {
                if(data.body.status == 200) {
                    this.lookbook = data.body.data; //refresh data
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }else{
                    this.data_processing_message = "Something went wrong"; 
                    this.deactivate_processing();
                    this.lookbook_details = {};
                }
            }).catch((err) => {
                if(err) {
                    this.deactivate_processing();
                    this.data_processing_message = "Something went wrong"; 
                    this.lookbook_details = {};
                }
            })
        },

        deletePostImage(image){
            this.activate_processing();
            var payload = {
                data_type: "gallery_media",
            }
            service.deleteImages(this, image, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.resetComponentData("lookbook");
                    this.deactivate_processing();
                }
            }).catch((err) => {})
        },
        //---./lookbook-settings---------/

        

        //resets
        resetComponentData(component){
            if(component == 'lookbook'){
                service.resetData(this,"gallery", this.lookbook.gallery_posts_group_url_name).then(response => {
                    if(response.body.status == 200) {
                        let lookbook = response.body.data;
                        for(let post of lookbook.gallery_posts_group_posts){
                            if(post.gallery_post_id == this.lookbook_post.gallery_post_id){
                                this.lookbook_post =  post
                            }
                        }
                        this.deactivate_processing();
                    }
                }).catch((err) => {})
            }
        },

        //uploads
        onFileChangePrep(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            }   
        
        },

        onFileChangeMultiplePrep(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length > 0)
            {   
                this.files_info = files;
                for(let file of files){
                    let formData = new FormData();
                    formData.append('photo', file); 
                    this.imagesFormArray.push(formData);
                }
            } 
        },

        onFileChange(e,type,data_id) {
            this.resetMessages(); //reset
            this.product_details = {}; //hack
            this.product_details.uploading_image = true;
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);  
                // formData.append('data_id', this.product_item.product_item_id);
                // formData.append('data_type', "product_items");   

                this.imageForm = formData;
                // if(!this.product_details.uploading_image){ //hack for disable double request
                    service.uploadDataPhoto(this, formData).then(data => {
                        if(data.body.status == 200){
                            if(type == "business_category"){
                                this.category.business_category_image = data.body.data;
                            }
                            // if(type == "product_item"){
                            //     this.product_item.product_item_image = data.body.data;
                            // }
                            if(type == "products"){
                                this.getProductImages();
                                if(this.product_details.editProductItemGroup){ //ie product_item_group edit going on
                                    this.product_item_group.product_item_group_image = data.body.data_id;
                                }
                            }
                            
                            if(type == "product_information"){
                                this.getProductInformation();
                            }

                            
                            this.deactivate_processing();
                            
                        }else{
                            this.data_processing_message = service.upload_media_error_msg;
                            this.deactivate_processing();
                        }
                        this.product_details.uploading_image = false;
                    }).catch((err) => {
                        this.data_processing_message = service.upload_media_error_msg;
                        this.deactivate_processing();
                        this.product_details.uploading_image = false;
                    })
                }
            // }   
                
        },
        //producta
        onFileChangeNewProduct(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            }   
        
        },
        //productitems
        onFileChangeProductItems(e,type,data_id) {
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);  
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == "products"){
                            this.product.product_item_group_image = data.body.data_id;
                            // this.data_media_error_message = "";
                            this.getProductImages();
                        }
                    }
                }).catch((err) => {
                    if(err) {
                        // log it
                    }
                })
                //if uploading takes time continue with reload
                this.data_media_error_message = service.media_upload_timeout_msg;
                let self = this;
                setTimeout(function(){  self.data_media_error_message; }, 65000); //wait for 1min and timeout
                setTimeout(function(){  
                    // location.reload(true); 
                    self.data_media_error_message = "";
                }, 95000); //wait for 1min and timeout
            }   
                
        },
        //lookbooks
        //uploads for adding media to gallery post
        onFileChangeLookbook(e,type,data_id) {
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);  
                
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == "gallery_media"){ 
                            this.resetComponentData("lookbook");
                        }
                    }else{
                        this.data_processing_message = "Sorry Upload Failed";
                    }
                    this.deactivate_processing();
                }).catch((err) => {
                    if(err) {
                        // log it
                        this.data_processing_message = "Sorry Upload Failed";
                        this.deactivate_processing();
                    }
                })
            }   
                
        },

        ///process payments paystack
        //connect to a payment gateway
        processPayment() {
            //some onboarding
            this.data_processing_message = "Preparing Payment Information";
            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.app_orders.payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.app_orders.payer_phone).toLowerCase());
            if((email_test == false) || (this.app_orders.payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
                this.deactivate_processing();
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                 //process online payment
                    let obj = this;
                    //this.amount_paid = data.plan_amount;
                    var handler = PaystackPop.setup({
                    // key: 'pk_live_64fe633bf8a53b0346ef8a44f54dc41cc0aa9f8b',
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.app_orders.payer_name,
                    // email: data.plan_user_email || "admin@sellpoints.ng",
                    email: this.app_orders.payer_email,
                    amount:  (Math.round(this.app_orders.pay_amount * 100)),//(data.plan_amount * 100), //in kobo
                    ref: this.app_orders.pay_ref,
                    metadata: {
                        custom_fields: [
                           {
                                display_name: "Service",
                                variable_name: "service_type",
                                value: this.app_orders.pay_service_details
                            }
                            
                        ]
                    },
                    
                    callback: function(response){
                        obj.updatePayment(response.trxref); 
                    },
                    onClose: function(){
                        alert('window closed');
                    }
                    });
                    handler.openIframe();
                }

        },

        // update payments
        updatePayment(payment_ref) {
            //after validation
            //
            this.postBusinessProcessingFeeTransaction(payment_ref);
        },

        //integrated servies

        getIntegratedServices(){
            //rave pay bank list
            service.getRavepayBanks().then(response => {
                this.ravepay_bank_list = response.data.data.Banks;
            })
        },


        //---------------html-cards
        getProductsCard(){
            return(`<div class="card col-xs-6 card-col-2" v-for="(product,index) in products" style="margin-bottom: 0.8em;"> 
              <a @click="postChatObject(product)" style="text-decoration: none; color:inherit; cursor: pointer;">
                <!-- <span class="card-thumb-up-left"><i class="fa fa-shopping-bag"></i></span> -->
                <div class="card-col-img" style="margin-bottom: 0.8em; border-left: #f5f5f5 solid 0.35em; border-radius: 4px;">
                  <img v-if="product.product_images[0]" :src="product.product_images[0].product_image" class="img-responsive">
                  <img v-else src="/static/assets/images/dummy-image.png">
                </div>
                <div class="card-col-details" style="display:block;">
                  <p style="font-size:13px; text-align: center;">{{product.product_name}}<br>
                    <span v-if="product.product_items[0]" class="sp-app-default-color">₦{{product.product_items[0].product_item_price_f}}</span>
                  </p>
                </div>
              </a>
            </div>`);
        
        },
        getProductCard(){
            if((this.product.product_images[0] != undefined) && (this.product.product_items[0] != undefined)){
                return (
                    // "<span class='plain-bold'>Producfftvv:</span> "+ this.product.product_name
                    `<div class='card card-01 timeline-user-card'> 
                        <div class="card-left">
                            <div class="card-avatar-square">
                            <img v-if="`+this.product.product_images[0]+`" src="`+this.product.product_images[0].product_image+`">
                            <img v-else src="/static/assets/images/dummy-image.png">
                            </div>
                        </div>
                        <div class="card-right">
                            <div class="card-arm-line">
                            <p>`+this.product.product_name+`<br>
                            <span v-if="`+this.product.product_items[0]+`">₦`+this.product.product_items[0].product_item_price_f+ ` - ` + `₦`+this.product.product_items[0].product_item_price_f+
                            `</span>
                            </p>

                            </div>
                    </div>`
                );
            }else{
                return (
                    `<div class='card card-label'> 
                        <div class="card-label-left">
                            <div class="card-avatar-square">
                            <img src="/static/assets/images/dummy-image.png">
                            </div>
                          </div>
                          <div class="card-label-right">
                            <div class="card-arm-line">
                              <p>`+this.product.product_name+`</p>
                         </div>
                    </div>`
                );
            }

        },


        //----------------html-cards

        //--------fix-headers

        setPageHeaders(){
            // When the user scrolls the page, execute myFunction
            window.onscroll = function() {
                // Get the header
                var stick_header = document.getElementById("pageStickyHeader");
                if((stick_header != this.undefined) || (stick_header != null)){
                    var main_stick_header = document.getElementById("mainStickyHeader");
                    var head_arrow_back = document.getElementById("headTagBack");
                    // Get the offset position of the navbar
                    var sticky = stick_header.offsetTop;
        
                    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
                    if (window.pageYOffset > sticky) {
                        main_stick_header.classList.add("header-main-unfix");
                        stick_header.classList.add("header-sticky-after-2");
                        // head_arrow_back.classList.add("element-display-block");
                        stick_header.style.marginTop = "1em"; //add more margin to help set
                        head_arrow_back.style.display = "block";
                        head_arrow_back.style.marginLeft = "-1em";
                        head_arrow_back.style.marginTop = "0.6em";
                    } else {
                        stick_header.classList.remove("header-sticky-after-2");
                        main_stick_header.classList.add("header-main-refix");
                        // head_arrow_back.classList.add("element-display-none");
                        head_arrow_back.style.display = "none";
                    }
                }
            };
        },

        unsetPageHeaders(){
            window.onscroll = function() {
                // Get the header
                var stick_header = document.getElementById("pageStickyHeader");
                var main_stick_header = document.getElementById("mainStickyHeader");
                var head_arrow_back = document.getElementById("headTagBack");
                // Get the offset position of the navbar
                // var sticky = stick_header.offsetTop;
    
                //    stick_header.classList.remove("header-sticky-after-2");
                   main_stick_header.classList.add("header-main-refix");
                   main_stick_header.classList.add("header-sticky");
                //    head_arrow_back.style.display = "none";
        
            };
        }
    


        //--------fix-headers
        /*-------------------------Adminboarding--------------------------------------*/
    },
    created: function(){
        document.title = "Account" + "";
        this.getStates();
        this.getCategories();
        this.getBusinessMarketGroups();
        this.getBusinessesOpenAgentsProducts(); //call here for now
        this.preset();
    }
}


// WEBPACK FOOTER //
// ./src/pages/AppWedeliver/Account/script.js